import React, { useState, useEffect, useContext, useRef } from "react";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import { useNavigate, useLocation } from "react-router-dom";
import config from "../../config";
import Select from "react-select";
import { ContextBoard } from "../../context/ContextBoard";
import Swal from "sweetalert2";
import { setSessionData, getSessionData } from "../../cache";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { FaRegFilePdf } from "react-icons/fa6";

function StudentCorrectionPage11() {
  const {
    class11candidateid,
    setcandidateData,
    class11jacstudent,
    setClass11Candidateid,
    setClass11Castecode,
    setClass11Divyangcode,
    class11mode,
  } = useContext(ContextBoard);
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = useLocation();
  const candidateData = state?.studentData || null;

  const photographRef = useRef();
  const signatureRef = useRef();
  const casteRef = useRef();
  const divyangRef = useRef();
  const cropperRef = useRef(null);

  const [photoFile, setPhotoFile] = useState(null);
  const [signFile, setSignFile] = useState(null);
  const [casteFile, setCasteFile] = useState(null);
  const [divyangFile, setDivyangFile] = useState(null);

  const [photoBase64, setPhotoBase64] = useState("");
  const [photoName, setPhotoName] = useState("");
  const [photourl, setPhotourl] = useState("");

  const [signBase64, setSignBase64] = useState("");
  const [signName, setSignName] = useState("");
  const [signurl, setSignurl] = useState("");

  const [casteBase64, setCasteBase64] = useState("");
  const [casteName, setCasteName] = useState("");
  const [casteurl, setCasteurl] = useState("");

  const [divyangBase64, setDivyangBase64] = useState("");
  const [divyangName, setDivyangName] = useState("");
  const [divyangurl, setDivyangurl] = useState("");

  const [photooriginalname, setPhotooriginalname] = useState("");
  const [signoriginalname, setSignoriginalname] = useState("");
  const [olddivyangFile, setOlddivyangFile] = useState(null);

  const [showCropper, setShowCropper] = useState(false);
  const [cropperImage, setCropperImage] = useState("");

  const [genderDisabled, setGenderDisabled] = useState(false);
  const [dobDisabled, setDobDisabled] = useState(false);
  const [fatherDisabled, setFatherDisabled] = useState(false);
  const [motherDisabled, setMotherDisabled] = useState(false);

  const [errors, setErrors] = useState({});
  const [isAgreed, setIsAgreed] = useState(false);

  const [blockList, setBlockList] = useState([]);
  const [casteList, setCasteList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [divyangList, setDivyangList] = useState([]);
  const [mediumList, setMediumList] = useState([]);
  const [religionList, setReligionList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [coresubject, setCoresubject] = useState([]);
  const [matribhasa, setMatribhasa] = useState([]);
  const [compulsory, setCompulsory] = useState([]);
  const [compulsoryfilter, setCompulsoryfilter] = useState([]);
  const [artsSubjects, setArtsSubjects] = useState([]);
  const [optionalsubj, setOptionalsubj] = useState([]);
  const [optionalfiltersubj, setOptionalfiltersubj] = useState([]);
  const [additionalsubj, setAdditionalsubj] = useState([]);
  const [additionalfiltersubj, setAdditionalfiltersubj] = useState([]);
  const [electivefiltersubj, setElectivefiltersubj] = useState([]);
  const [compulsoryonename, setCompulsoryonename] = useState("");
  const [compulsorytwoname, setCompulsorytwoname] = useState("");

  const [loading, setLoading] = useState(false);
  const [isPreviewed, setIsPreviewed] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [showSubmit, setShowSubmit] = useState(false);

  const [formData, setFormData] = useState({
    candidate_name: "",
    gender: "",
    date_of_birth: "",
    fathers_name: "",
    mothers_name: "",
    religion: "",
    nationality: "Indian",
    aadhaar_no: "",
    divyang_val: "",
    caste_val: "",
    area: "",
    state_val: "",
    district_val: "",
    block_val: "",
    address_val: "",
    pin_no: "",
    contact_no: "",
    email_id: "",
    board_name: "JAC",
    apaar_id: "",
    section_val: "",
    roll_no: "",
    class_roll_no: "",
    stream: "",
    coresubject: "",
    matribhasa: "",
    compulsory_one: "",
    compulsory_two: "",
    additionalsubject: "",
    category_choice: "",
    pen_no: "",
  });

  const [selectedArtsSubjects, setSelectedArtsSubjects] = useState({
    arts_optional_one: "",
    arts_optional_two: "",
    arts_optional_three: "",
  });

  const [optional1, setOptional1] = useState("");
  const [optional2, setOptional2] = useState("");
  const [artselective, setArtselective] = useState("");

  const [selectedSubjectNames, setSelectedSubjectNames] = useState({
    coresubject: "",
    matribhasa: "",
    // compulsory_one: "",
    // compulsory_two: "",
    additionalsubject: "",
    arts_optional_one: "",
    arts_optional_two: "",
    arts_optional_three: "",
    optional1: "",
    optional2: "",
    artselective: "",
  });

  useEffect(() => {
    // ✅ Hindi restrictions
    if (
      formData.coresubject === "HNA" &&
      (formData.additionalsubject === "HIN" || artselective === "HIN")
    ) {
      setFormData((prev) => ({
        ...prev,
        additionalsubject: "",
      }));
      if (artselective === "HIN") {
        setArtselective("");
        setSelectedSubjectNames((prev) => ({ ...prev, artselective: "" }));
      }
    }
    if (formData.coresubject === "HNA" && artselective === "HIN") {
      setArtselective("");
      setFormData((prev) => ({
        ...prev,
        additionalsubject: "",
      }));
    }
    // ✅ English restrictions
    if (
      formData.coresubject === "ENA" &&
      (formData.additionalsubject === "ENG" ||
        formData.additionalsubject === "FEN" ||
        artselective === "ENG" ||
        artselective === "FEN")
    ) {
      setFormData((prev) => ({
        ...prev,
        additionalsubject: "",
      }));
      if (artselective === "ENG" || artselective === "FEN") {
        setArtselective("");
        setSelectedSubjectNames((prev) => ({ ...prev, artselective: "" }));
      }
    }

    // ✅ Science stream restrictions
    if (formData.stream === "SCIENCE") {
      if (
        (optional1 === "MAT" || optional2 === "MAT") &&
        formData.additionalsubject === "STA"
      ) {
        setFormData((prev) => ({
          ...prev,
          additionalsubject: "",
        }));
      }
      if (
        (optional1 === "STA" || optional2 === "STA") &&
        formData.additionalsubject === "MAT"
      ) {
        setFormData((prev) => ({
          ...prev,
          additionalsubject: "",
        }));
      }
    }

    // ✅ Commerce stream restrictions
    if (formData.stream === "COMMERCE") {
      if (
        (optional1 === "MAT" || optional2 === "MAT") &&
        formData.additionalsubject === "CAE"
      ) {
        setFormData((prev) => ({
          ...prev,
          additionalsubject: "",
        }));
      }
      if (
        (optional1 === "CAE" || optional2 === "CAE") &&
        formData.additionalsubject === "MAT"
      ) {
        setFormData((prev) => ({
          ...prev,
          additionalsubject: "",
        }));
      }
    }

    // ✅ Arts stream restrictions
    if (formData.stream === "ARTS") {
      const { arts_optional_one, arts_optional_two, arts_optional_three } =
        selectedArtsSubjects;

      // If MAT selected anywhere, clear additionalsubject if it's MAT/STA
      if (
        arts_optional_one === "MAT" ||
        arts_optional_two === "MAT" ||
        arts_optional_three === "MAT"
      ) {
        if (
          formData.additionalsubject === "MAT" ||
          formData.additionalsubject === "STA"
        ) {
          setFormData((prev) => ({
            ...prev,
            additionalsubject: "",
          }));
        }
      }

      // If STA selected anywhere, clear additionalsubject if it's MAT/STA
      if (
        arts_optional_one === "STA" ||
        arts_optional_two === "STA" ||
        arts_optional_three === "STA"
      ) {
        if (
          formData.additionalsubject === "STA" ||
          formData.additionalsubject === "MAT"
        ) {
          setFormData((prev) => ({
            ...prev,
            additionalsubject: "",
          }));
        }
      }
    }
  }, [
    formData.coresubject,
    formData.stream,
    formData.additionalsubject,
    optional1,
    optional2,
    selectedArtsSubjects,
  ]);

  useEffect(() => {
    if (formData.stream === "ARTS") {
      const { arts_optional_one, arts_optional_two, arts_optional_three } =
        selectedArtsSubjects;

      // If MAT is selected anywhere → reset STA from additional subject
      if (
        (arts_optional_one === "MAT" ||
          arts_optional_two === "MAT" ||
          arts_optional_three === "MAT") &&
        formData.additionalsubject === "STA"
      ) {
        setFormData((prev) => ({ ...prev, additionalsubject: "" }));
        return;
      }

      // If STA is selected anywhere → reset MAT from additional subject
      if (
        (arts_optional_one === "STA" ||
          arts_optional_two === "STA" ||
          arts_optional_three === "STA") &&
        formData.additionalsubject === "MAT"
      ) {
        setFormData((prev) => ({ ...prev, additionalsubject: "" }));
        return;
      }
    }
  }, [
    formData.stream,
    formData.additionalsubject,
    selectedArtsSubjects.arts_optional_one,
    selectedArtsSubjects.arts_optional_two,
    selectedArtsSubjects.arts_optional_three,
  ]);

  useEffect(() => {
    // 🔹 Science stream MAT–STA restrictions
    if (formData.stream === "SCIENCE") {
      // If MAT chosen in optional1/optional2 → additional subject cannot be STA
      if (
        (optional1 === "MAT" || optional2 === "MAT") &&
        formData.additionalsubject === "STA"
      ) {
        setFormData((prev) => ({ ...prev, additionalsubject: "" }));
        return;
      }

      // If STA chosen in optional1/optional2 → additional subject cannot be MAT
      if (
        (optional1 === "STA" || optional2 === "STA") &&
        formData.additionalsubject === "MAT"
      ) {
        setFormData((prev) => ({ ...prev, additionalsubject: "" }));
        return;
      }
    }

    // 🔹 Commerce stream MAT–CAE restrictions
    if (formData.stream === "COMMERCE") {
      // If MAT chosen in optional1/optional2 → additional subject cannot be CAE
      if (
        (optional1 === "MAT" || optional2 === "MAT") &&
        formData.additionalsubject === "CAE"
      ) {
        setFormData((prev) => ({ ...prev, additionalsubject: "" }));
        return;
      }

      // If CAE chosen in optional1/optional2 → additional subject cannot be MAT
      if (
        (optional1 === "CAE" || optional2 === "CAE") &&
        formData.additionalsubject === "MAT"
      ) {
        setFormData((prev) => ({ ...prev, additionalsubject: "" }));
        return;
      }
    }
  }, [formData.stream, formData.additionalsubject, optional1, optional2]);

  // Redirect if candidateData is not available or empty object
  useEffect(() => {
    if (!candidateData || Object.keys(candidateData).length === 0) {
      navigate("/class-xi-add-student-jac");
    }
  }, [candidateData, navigate]);

  useEffect(() => {
    // 🔹 Read encrypted lists from sessionStorage
    const blockList = getSessionData("blockList") || [];
    const casteList = getSessionData("casteList") || [];
    const districtList = getSessionData("districtList") || [];
    const divyangList = getSessionData("divyangList") || [];
    const mediumList = getSessionData("mediumList") || [];
    const religionList = getSessionData("religionList") || [];
    const stateList = getSessionData("stateList") || [];
    const coreSubjects = getSessionData("coreSubjects") || [];
    const matri_BhasaSubjects = getSessionData("matri_BhasaSubjects") || [];
    const compulsory_Paper_2Subjects =
      getSessionData("compulsory_Paper_2Subjects") || [];
    const additional_Subjects = getSessionData("additional_Subjects") || [];
    const optional_Paper_1_2Subjects =
      getSessionData("optional_Paper_1_2Subjects") || [];
    const elective_Subjects = getSessionData("electivesubj") || [];
    // 🔹 Set lists into state
    setBlockList(Array.isArray(blockList) ? blockList : []);
    setCasteList(Array.isArray(casteList) ? casteList : []);
    setDistrictList(Array.isArray(districtList) ? districtList : []);
    setDivyangList(Array.isArray(divyangList) ? divyangList : []);
    setMediumList(Array.isArray(mediumList) ? mediumList : []);
    setReligionList(Array.isArray(religionList) ? religionList : []);
    setStateList(Array.isArray(stateList) ? stateList : []);
    setCoresubject(Array.isArray(coreSubjects) ? coreSubjects : []);
    setMatribhasa(
      Array.isArray(matri_BhasaSubjects) ? matri_BhasaSubjects : []
    );
    setCompulsory(
      Array.isArray(compulsory_Paper_2Subjects)
        ? compulsory_Paper_2Subjects
        : []
    );
    setAdditionalsubj(
      Array.isArray(additional_Subjects) ? additional_Subjects : []
    );
    setOptionalsubj(
      Array.isArray(optional_Paper_1_2Subjects)
        ? optional_Paper_1_2Subjects
        : []
    );
    setElectivefiltersubj(
      Array.isArray(elective_Subjects) ? elective_Subjects : []
    );
    // 🔹 Aadhaar formatting
    const stream = candidateData?.stream || "";
    const rawAadhaar = candidateData?.aadhaR_CARD || "";
    const digitsOnly = rawAadhaar.replace(/\D/g, "").slice(0, 12);
    const formattedAadhaar = digitsOnly.replace(
      /(\d{4})(\d{4})(\d{1,4})?/,
      (_, p1, p2, p3 = "") => [p1, p2, p3].filter(Boolean).join(" ")
    );

    // 🔹 Filter subjects by stream
    const filteredCompulsory =
      compulsory_Paper_2Subjects?.filter(
        (subj) => subj.streams === stream || subj.streams === "ALL"
      ) || [];

    const filteredOptional =
      optional_Paper_1_2Subjects?.filter(
        (subj) => subj.streams === stream || subj.streams === "ALL"
      ) || [];

    const filteredAdditional =
      additional_Subjects?.filter(
        (subj) => subj.streams === stream || subj.streams === "ALL"
      ) || [];

    // 🔹 Apply stream-based subject logic
    if (stream === "SCIENCE" || stream === "COMMERCE") {
      const [firstComp, secondComp] = filteredCompulsory;
      setCompulsoryonename(firstComp?.subjecT_NAME || "");
      setCompulsorytwoname(secondComp?.subjecT_NAME || "");

      setFormData((prev) => ({
        ...prev,
        compulsory_one: firstComp?.subjecT_ID || "",
        compulsory_two: secondComp?.subjecT_ID || "",
      }));

      setOptionalfiltersubj(filteredOptional);
      setAdditionalfiltersubj(filteredAdditional);

      setOptional1(candidateData.subjecT_4_CODE || "");
      setOptional2(candidateData.subjecT_5_CODE || "");
    } else if (stream === "ARTS") {
      setArtsSubjects(filteredCompulsory);
      setOptionalfiltersubj(filteredOptional);
      setAdditionalfiltersubj(filteredAdditional);
      setSelectedArtsSubjects({
        arts_optional_one: candidateData.subjecT_3_CODE || "",
        arts_optional_two: candidateData.subjecT_4_CODE || "",
        arts_optional_three: candidateData.subjecT_5_CODE || "",
      });
      setArtselective(candidateData.subjecT_2_CODE || "");
    }
    if (candidateData.gender) {
      setGenderDisabled(true);
    }

    if (candidateData.doB_1) {
      setDobDisabled(true);
    }

    // Father's & Mother's name editable
    // if (candidateData.fatheR_NAME) setFatherDisabled(true);
    // if (candidateData.motheR_NAME) setMotherDisabled(true);

    // 🔹 Set common student details
    setFormData((prev) => ({
      ...prev,
      candidate_name: candidateData?.candidatE_NAME || "",
      pen_no: candidateData?.peN_NO || "",
      gender: candidateData?.gender?.toUpperCase() || "",
      date_of_birth: candidateData?.dob || "",
      fathers_name: candidateData?.fatheR_NAME || "",
      mothers_name: candidateData?.motheR_NAME || "",
      religion: candidateData?.religion || "",
      nationality: "Indian",
      aadhaar_no: formattedAadhaar || "",
      divyang_val: candidateData?.divyang || "",
      caste_val: candidateData?.caste || "",
      area: candidateData?.area || "",
      state_val: candidateData?.state || "",
      district_val: candidateData?.districT_ID || "",
      block_val: candidateData?.block || "",
      address_val: candidateData?.address || "",
      pin_no: candidateData?.pincode || "",
      contact_no: candidateData?.contacT_NO || "",
      email_id: candidateData?.emaiL_ID || "",
      category_choice: candidateData?.studenT_EXAM_CATEGORY_DESCRIPTION || "",
      section_val: candidateData?.section || "",
      roll_no: candidateData?.clasS_ROLL_NO || "",
      class_roll_no: candidateData?.olD_ROLL_NO || "",
      stream: stream,
      coresubject: candidateData?.subjecT_1_A_CODE || "",
      matribhasa: candidateData?.subjecT_1_B_CODE || "",
      additionalsubject: candidateData?.subjecT_6_CODE || "",
      apaar_id: candidateData.apaaR_ID || "",
    }));

    setPhotoName(candidateData?.studenT_PHOTOGRAPH || "");
    setPhotooriginalname(candidateData?.studenT_PHOTOGRAPH || "");
    setSignoriginalname(candidateData?.studenT_SIGNATURE || "");
    setSignName(candidateData?.studenT_SIGNATURE || "");
    setCasteName(candidateData?.castE_CERTIFICATE || "");
    setDivyangName(candidateData?.divyanG_CERTIFICATE || "");
    setPhotourl(candidateData?.studenT_PHOTOGRAPH_URL || "");
    setSignurl(candidateData?.studenT_SIGNATURE_URL || "");
    setCasteurl(candidateData?.castE_CERTIFICATE_URL || "");
    setDivyangurl(candidateData?.divyanG_CERTIFICATE_URL || "");
    setOlddivyangFile(candidateData?.divyanG_CERTIFICATE || "");

    setLoading(false);

    if (class11mode === "edit") {
      setIsEditMode(true);
      setIsPreviewed(true);
    }
  }, [candidateData]);

  const handleChange = (e) => {
    const { name, value = "" } = e.target;

    let formattedValue = value;
    if (
      name === "candidate_name" ||
      name === "fathers_name" ||
      name === "mothers_name"
    ) {
      formattedValue = value
        .toUpperCase()
        .replace(/[^A-Z\s]/g, "")
        .slice(0, 35);
    }
    if (name === "aadhaar_no") {
      const digitsOnly = value.replace(/\D/g, "").slice(0, 12);
      formattedValue = digitsOnly.replace(
        /(\d{4})(\d{4})(\d{1,4})?/,
        (_, p1, p2, p3 = "") => [p1, p2, p3].filter(Boolean).join(" ")
      );
    } else if (name === "pen_no") {
      formattedValue = value.replace(/\D/g, "");
    }

    // Dependent dropdown resets
    if (name === "state_val") {
      setFormData((prev) => ({
        ...prev,
        state_val: formattedValue,
        district_val: "",
        block_val: "",
      }));
    } else if (name === "district_val") {
      setFormData((prev) => ({
        ...prev,
        district_val: formattedValue,
        block_val: "",
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: formattedValue,
      }));
    }

    // Clear errors on change
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handlePreview = async () => {
    setLoading(true);
    const trimmed = (val) => (val || "").trim();
    // const rawPen = formData.pen_no?.trim();
    // if (rawPen) {
    //   const penno = rawPen.replace(/\s/g, "");
    //   if (penno && penno.length >= 11 && penno.length <= 14) {
    //     const token = sessionStorage.getItem("tokenclassxi");
    //     try {
    //       const response = await fetch(
    //         `${config.API_BASE_URL}/PENNoCheckingStudentData_CL11`,
    //         {
    //           method: "POST",
    //           headers: {
    //             "Content-Type": "application/json",
    //             Authorization: `Bearer ${token}`,
    //           },
    //           body: JSON.stringify({
    //             candidatE_ID: class11candidateid || "",
    //             peN_NO: penno,
    //           }),
    //         }
    //       );
    //       const result = await response.json();
    //       if (result.status === 404) {
    //         Swal.fire({
    //           icon: "warning",
    //           title:
    //             "PEN (Permanent Education Number) No. Already Exists For Other Candidate.",
    //         });
    //         setFormData((prev) => ({
    //           ...prev,
    //           pen_no: "",
    //         }));
    //         setLoading(false);
    //         return;
    //       }
    //     } catch (error) {
    //       console.error("Error verifying PEN No.", error);
    //       setLoading(false);
    //       return;
    //     }
    //   }
    // }


    const newErrors = {};
    const candidateName = trimmed(formData.candidate_name);
    const fathersName = trimmed(formData.fathers_name);
    const mothersName = trimmed(formData.mothers_name);
    setTimeout(() => {
      // Validation logic here (abbreviated for brevity)
      if (!formData.gender) newErrors.gender = "Gender is required.";
      if (!formData.date_of_birth)
        newErrors.date_of_birth = "Date of Birth is required.";

      if (candidateName) {
        if (
          fathersName &&
          mothersName &&
          candidateName.toLowerCase() === fathersName.toLowerCase() &&
          candidateName.toLowerCase() === mothersName.toLowerCase()
        ) {
          newErrors.candidate_name =
            "Candidate name cannot be the same as Father's and Mother's name.";
          newErrors.fathers_name =
            "Father's name cannot be the same as Candidate and Mother's name.";
          newErrors.mothers_name =
            "Mother's name cannot be the same as Candidate and Father's name.";
          toast.error(
            "All names are the same! Candidate, Father's name, and Mother's name cannot be the same."
          );
        } else {
          if (
            fathersName &&
            candidateName.toLowerCase() === fathersName.toLowerCase()
          ) {
            newErrors.candidate_name =
              "Candidate name cannot be the same as Father's name.";
            newErrors.fathers_name =
              "Father's name cannot be the same as Candidate name.";
            toast.error(
              "Duplicate names! Candidate name cannot be the same as Father's name."
            );
          }
          if (
            mothersName &&
            candidateName.toLowerCase() === mothersName.toLowerCase()
          ) {
            newErrors.candidate_name =
              "Candidate name cannot be the same as Mother's name.";
            newErrors.mothers_name =
              "Mother's name cannot be the same as Candidate name.";
            toast.error(
              "Duplicate names! Candidate name cannot be the same as Mother's name."
            );
          }
          if (
            fathersName &&
            mothersName &&
            fathersName.toLowerCase() === mothersName.toLowerCase()
          ) {
            newErrors.fathers_name =
              "Father's name cannot be the same as Mother's name.";
            newErrors.mothers_name =
              "Mother's name cannot be the same as Father's name.";
            toast.error(
              "Duplicate names! Father's name cannot be the same as Mother's name."
            );
          }
        }
      }
      if (!trimmed(formData.candidate_name))
        newErrors.candidate_name = "Candidate Name is required.";
      if (!trimmed(formData.mothers_name))
        newErrors.mothers_name = "Mother Name is required.";
      if (!trimmed(formData.fathers_name))
        newErrors.fathers_name = "Father Name is required.";
      if (!formData.divyang_val)
        newErrors.divyang_val = "Divyang selection is required.";
      if (!formData.caste_val) newErrors.caste_val = "Caste is required.";
      if (!formData.religion) newErrors.religion = "Religion is required.";

      // Aadhaar validation removed as field is removed
      // const aadhaar = (formData.aadhaar_no || "").replace(/\D/g, "");
      // if (!aadhaar) {
      //   newErrors.aadhaar_no = "Aadhaar number is required.";
      // } else if (!/^\d{12}$/.test(aadhaar)) {
      //   newErrors.aadhaar_no = "Aadhaar number must be 12 digits.";
      // }
      // if (!formData.area) newErrors.area = "Area is required.";

      // if (!trimmed(formData.state_val))
      //   newErrors.state_val = "State is required.";
      // if (!trimmed(formData.district_val))
      //   newErrors.district_val = "District is required.";
      // if (!trimmed(formData.block_val))
      //   newErrors.block_val = "Block is required.";
      // if (!trimmed(formData.address_val))
      //   newErrors.address_val = "Address is required.";

      // if (!trimmed(formData.pin_no)) {
      //   newErrors.pin_no = "Pin code is required.";
      // } else if (!/^\d{6}$/.test(formData.pin_no)) {
      //   newErrors.pin_no = "Pin code must be 6 digits.";
      // }

      // if (!trimmed(formData.contact_no)) {
      //   newErrors.contact_no = "Contact number is required.";
      // } else if (!/^\d{10}$/.test(formData.contact_no)) {
      //   newErrors.contact_no = "Contact number must be 10 digits.";
      // }

      // if (
      //   formData.email_id &&
      //   !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.email_id)
      // ) {
      //   newErrors.email_id = "Invalid email format.";
      // }
      if (!formData.stream) newErrors.stream = "Stream is required.";
      // More validations for streams and subjects, as in your code...
      if (formData.category_choice === "REGULAR" || formData.category_choice === "PRIVATE") {
        if (formData.stream === "SCIENCE" || formData.stream === "COMMERCE") {
          if (!formData.coresubject) {
            newErrors.coresubject = "Core Language is Required.";
          }
          if (formData.coresubject === "HNB") {
            if (!formData.matribhasa) {
              newErrors.matribhasa = "Matri Bhasa is Required.";
            }
          }
          if (!optional1) {
            newErrors.sc_optional_one = "Optional 1 is Required.";
          }
          if (!optional2) {
            newErrors.sc_optional_two = "Optional 2 is Required.";
          }
        }
        if (formData.stream === "ARTS") {
          if (!formData.coresubject) {
            newErrors.coresubject = "Core Language is Required.";
          }
          if (formData.coresubject === "HNB") {
            if (!formData.matribhasa) {
              newErrors.matribhasa = "Matri Bhasa is Required.";
            }
          }
          if (!selectedArtsSubjects.arts_optional_one) {
            newErrors.arts_optional_one = "Optional 1 is Required.";
          }
          if (!selectedArtsSubjects.arts_optional_two) {
            newErrors.arts_optional_two = "Optional 2 is Required.";
          }
          if (!selectedArtsSubjects.arts_optional_three) {
            newErrors.arts_optional_three = "Optional 3 is Required.";
          }
          if (!artselective) {
            newErrors.arts_elective_one = "Elective Language is Required.";
          }
        }
      }
      // Other validations...

      // const apaar = (formData.apaar_id || "").replace(/\D/g, "");
      // if (apaar && !/^\d{12}$/.test(apaar))
      //   newErrors.apaar_id = "APAAR ID must be 12 digits.";
      if (formData.category_choice !== "EX-REGULAR") {
        if (!trimmed(formData.pen_no)) {
          newErrors.pen_no = "PEN No. is required.";
        } else if (!/^\d{11,14}$/.test(formData.pen_no)) {
          newErrors.pen_no = "PEN No. must be between 11 to 14 digits.";
        }
        if (!/^\d{12}$/.test(formData.apaar_id) && formData.apaar_id) {
          newErrors.apaar_id = "Apaar ID must be exactly 12 digits.";
        }
      }

      // if (!trimmed(formData.roll_no))
      //   newErrors.roll_no = "Class roll number is required.";

      // Duplicate subject check
      // const subjectFields = [
      //   formData.language_one,
      //   formData.language_two,
      //   formData.compulsory_one,
      //   formData.compulsory_two,
      //   formData.compulsory_three,
      //   formData.additional_subject,
      // ];

      // const counts = subjectFields.reduce((acc, subj) => {
      //   if (subj) {
      //     acc[subj] = (acc[subj] || 0) + 1;
      //   }
      //   return acc;
      // }, {});

      // const duplicates = Object.keys(counts).filter((subj) => counts[subj] > 1);
      // if (duplicates.length > 0) {
      //   Swal.fire(
      //     "Duplicate Subject Detected",
      //     `The subject "${duplicates[0]}" is selected multiple times. Each subject must be unique.`,
      //     "error"
      //   );
      //   setLoading(false);
      //   return;
      // }
      setErrors(newErrors);
      const noErrors = Object.keys(newErrors).length === 0;
      setShowSubmit(noErrors);
      if (!noErrors) {
        const firstErrorKey = Object.keys(newErrors)[0];
        const firstErrorElement = document.querySelector(
          `[name="${firstErrorKey}"]`
        );
        if (firstErrorElement) {
          firstErrorElement.focus();
        }
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
        setIsPreviewed(true);
      }
      setLoading(false);
    }, 500);
  };

  const handleEditClick = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to edit this profile?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Edit",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        setIsEditMode(false);
        setIsPreviewed(false);
      }
    });
  };

  const handleContinueClick = async () => {
    if (!isAgreed) {
      await Swal.fire({
        icon: "warning",
        title: "Please Agree",
        text: "You must agree before submitting the form.",
      });
      return;
    }
    // setcandidateData("");
    navigate("/class-xi-upload-document");
  };

  const handleArtsSubjects = () => {
    setSelectedSubjectNames((prevData) => ({
      ...prevData,
      coresubject: "",
      matribhasa: "",
      additionalsubject: "",
      arts_optional_one: "",
      arts_optional_two: "",
      arts_optional_three: "",
      optional1: "",
      optional2: "",
      artselective: "",
    }));
    setFormData((prevData) => ({
      ...prevData,
      coresubject: "",
      matribhasa: "",
      compulsory_one: "",
      compulsory_two: "",
      additionalsubject: "",
    }));
    setSelectedArtsSubjects({
      arts_optional_one: "",
      arts_optional_two: "",
      arts_optional_three: "",
    });
    setOptional1("");
    setOptional2("");
    setArtselective("");

    // Include ARTS + ALL
    const filtered = compulsory.filter(
      (subject) => subject.streams === "ARTS" || subject.streams === "ALL"
    );
    setArtsSubjects(filtered);

    const filteredOptional = optionalsubj.filter(
      (subject) => subject.streams === "ARTS" || subject.streams === "ALL"
    );
    const filteredadditional = additionalsubj.filter(
      (subject) => subject.streams === "ARTS" || subject.streams === "ALL"
    );
    setAdditionalfiltersubj(filteredadditional);
    setOptionalfiltersubj(filteredOptional);
  };

  const handleSetCompulsorySubjects = (selectedStream) => {
    setSelectedSubjectNames((prevData) => ({
      ...prevData,
      coresubject: "",
      matribhasa: "",
      additionalsubject: "",
      arts_optional_one: "",
      arts_optional_two: "",
      arts_optional_three: "",
      optional1: "",
      optional2: "",
      artselective: "",
    }));
    setFormData((prevData) => ({
      ...prevData,
      coresubject: "",
      matribhasa: "",
      compulsory_one: "",
      compulsory_two: "",
      additionalsubject: "",
    }));
    setSelectedArtsSubjects({
      arts_optional_one: "",
      arts_optional_two: "",
      arts_optional_three: "",
    });
    setOptional1("");
    setOptional2("");
    setArtselective("");

    if (!Array.isArray(compulsory)) return;
    if (!Array.isArray(optionalsubj)) return;
    if (!Array.isArray(additionalsubj)) return;

    // Include selected stream + ALL
    const filteredSubjects = compulsory.filter(
      (subject) =>
        subject.streams === selectedStream || subject.streams === "ALL"
    );
    const filteredOptionalSubjects = optionalsubj.filter(
      (subject) =>
        subject.streams === selectedStream || subject.streams === "ALL"
    );
    const filteredadditionalSubjects = additionalsubj.filter(
      (subject) =>
        subject.streams === selectedStream || subject.streams === "ALL"
    );

    setAdditionalfiltersubj(filteredadditionalSubjects);
    setOptionalfiltersubj(filteredOptionalSubjects);

    const [firstSubject, secondSubject] = filteredSubjects;
    setCompulsoryonename(firstSubject?.subjecT_NAME || "");
    setCompulsorytwoname(secondSubject?.subjecT_NAME || "");

    setFormData((prev) => ({
      ...prev,
      compulsory_one: firstSubject?.subjecT_ID || "",
      compulsory_two: secondSubject?.subjecT_ID || "",
    }));
  };

  // const getFilteredArtsOptions = (excludeKeys) => {
  //   const selectedValues = Object.entries(selectedArtsSubjects)
  //     .filter(([key]) => excludeKeys.includes(key))
  //     .map(([, value]) => value);

  //   return artsSubjects.filter(
  //     (subject) => !selectedValues.includes(subject.subjecT_ID)
  //   );
  // };

  const handleArtsOptionalChange = (e) => {
    const { name, value } = e.target;

    setSelectedArtsSubjects((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // const filteredForOptional1 = optionalfiltersubj.filter(
  //   (subject) => subject.subjecT_ID !== optional2
  // );
  // const filteredForOptional2 = optionalfiltersubj.filter(
  //   (subject) => subject.subjecT_ID !== optional1
  // );

  // Document related functions
  const validateFile = (file, type) => {
    const validTypes =
      type === "image"
        ? ["image/jpeg", "image/jpg"]
        : ["application/pdf"];

    const minSize = type === "image" ? 10 * 1024 : 30 * 1024; // 10KB / 30KB
    const maxSize = type === "image" ? 40 * 1024 : 300 * 1024; // 40KB / 300KB

    if (!validTypes.includes(file.type)) {
      Swal.fire({
        icon: "error",
        title: "Invalid File",
        text:
          type === "image"
            ? "Please upload a JPG or JPEG image."
            : "Please upload a PDF file.",
      });
      return false;
    }

    if (file.size < minSize || file.size > maxSize) {
      Swal.fire({
        icon: "error",
        title: "Invalid File Size",
        text:
          type === "image"
            ? "Image size must be between 10KB and 40KB."
            : "PDF size must be between 30KB and 300KB.",
      });
      return false;
    }

    return true;
  };

  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (!file) return;

    const fileType = ["photograph", "signature"].includes(type)
      ? "image"
      : "pdf";
    const isValid = validateFile(file, fileType);

    if (!isValid) {
      if (type === "photograph" && photographRef.current)
        photographRef.current.value = "";
      if (type === "signature" && signatureRef.current)
        signatureRef.current.value = "";
      if (type === "caste" && casteRef.current) casteRef.current.value = "";
      if (type === "divyang" && divyangRef.current)
        divyangRef.current.value = "";
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      const base64 = reader.result;
      if (type === "photograph") {
        setPhotoBase64(base64);
        setPhotoName(file.name);
      } else if (type === "signature") {
        setSignBase64(base64);
        setSignName(file.name);
      } else if (type === "caste") {
        setCasteBase64(base64);
        setCasteName(file.name);
      } else if (type === "divyang") {
        setDivyangBase64(base64);
        setDivyangName(file.name);
      }
    };
    reader.readAsDataURL(file);
  };

  const handleChange2 = (e, type) => {
    const file = e.target.files[0];
    if (!file) return;

    const fileType = ["photograph", "signature"].includes(type)
      ? "image"
      : "pdf";

    const isValid = validateFile(file, fileType);

    if (!isValid) {
      if (type === "photograph" && photographRef.current)
        photographRef.current.value = "";
      if (type === "signature" && signatureRef.current)
        signatureRef.current.value = "";
      if (type === "caste" && casteRef.current) casteRef.current.value = "";
      if (type === "divyang" && divyangRef.current)
        divyangRef.current.value = "";
      return;
    }

    if (type === "photograph") setPhotoFile(file);
    if (type === "signature") setSignFile(file);
    if (type === "caste") setCasteFile(file);
    if (type === "divyang") setDivyangFile(file);

    const reader = new FileReader();
    reader.onloadend = () => {
      let base64 = reader.result;
      const cleanBase64 = base64.replace(/\s/g, "");

      if (type === "photograph") {
        setPhotoBase64(cleanBase64);
        setPhotoName(file.name);
        setCropperImage(cleanBase64);
        setShowCropper(true);
      }

      if (type === "signature") {
        setSignBase64(cleanBase64);
        setSignName(file.name);
      }

      if (type === "caste") {
        setCasteBase64(cleanBase64);
        setCasteName(file.name);
      }

      if (type === "divyang") {
        setDivyangBase64(cleanBase64);
        setDivyangName(file.name);
      }
    };

    reader.readAsDataURL(file);
  };

  const handleCropCancel = () => {
    setShowCropper(false);
    setPhotoFile(null);
    setPhotoBase64("");
    setCropperImage("");

    if (photographRef.current) {
      photographRef.current.value = "";
    }
    setTimeout(() => {
      setPhotoFile(null);
      setCropperImage("");
    }, 0);
  };

  const handleCropConfirm = async () => {
    if (!cropperRef.current) return;

    const croppedCanvas = cropperRef.current.cropper.getCroppedCanvas({
      width: 300,
      height: 400,
    });

    const croppedDataUrl = croppedCanvas.toDataURL("image/jpeg");
    const img = new Image();
    img.src = croppedDataUrl;

    img.onload = async () => {
      try {
        const grayImg = await convertToGrayscale(img);

        setPhotoBase64(grayImg.src);
        setPhotoName(photoFile?.name || "cropped-photo.jpg");

        croppedCanvas.toBlob((blob) => {
          if (blob) {
            const croppedFile = new File(
              [blob],
              photoFile?.name || "cropped-photo.jpg",
              {
                type: "image/jpeg",
              }
            );
            setPhotoFile(croppedFile);
          }
        }, "image/jpeg");

        setShowCropper(false);
      } catch (err) {
        toast.error(err.message);
      }
    };
  };

  function convertToGrayscale(img) {
    return new Promise((resolve) => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;

      for (let i = 0; i < data.length; i += 4) {
        const avg = 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];
        data[i] = data[i + 1] = data[i + 2] = avg;
      }
      ctx.putImageData(imageData, 0, 0);
      const grayDataUrl = canvas.toDataURL("image/jpeg");
      const grayImg = new Image();
      grayImg.src = grayDataUrl;
      grayImg.onload = () => resolve(grayImg);
    });
  }

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!validateFile(file, "image")) {
      if (photographRef.current) photographRef.current.value = "";
      return;
    }

    setPhotoFile(file);

    const reader = new FileReader();
    reader.onloadend = () => {
      setCropperImage(reader.result);
      setShowCropper(true);
    };
    reader.readAsDataURL(file);
  };

  const handleButtonClick = () => {
    handleSubmit();
  };

  const handleSubmit = async () => {
    const token =
      sessionStorage.getItem("intermediateAdminToken") ||
      sessionStorage.getItem("tokenclassxi");

    if (!isAgreed) {
      await Swal.fire({
        icon: "warning",
        title: "Please Agree",
        text: "You must agree before submitting the form.",
      });
      return;
    }

    // Convert Buffer/File → Base64
    const convertToBase64 = (file) =>
      new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(file);
      });

    if (formData.divyang_val === "DIV_001") {
      if (typeof setDivyangFile === "function") setDivyangFile(null);
      if (typeof setOlddivyangFile === "function") setOlddivyangFile("");
      if (typeof setDivyangName === "function") setDivyangName("");
    }

    /* -------------------------------------------------------
      CHANGE STATUS FLAGS — ONLY "YES" IF NEW FILE UPLOADED
     ------------------------------------------------------- */

    const PHOTO_CHANGE = typeof photoFile !== "undefined" && photoFile ? "YES" : "NO";
    const SIGN_CHANGE = typeof signFile !== "undefined" && signFile ? "YES" : "NO";
    const CASTE_CHANGE = typeof casteFile !== "undefined" && casteFile ? "YES" : "NO";
    const DIVYANG_CHANGE = typeof divyangFile !== "undefined" && divyangFile ? "YES" : "NO";

    /* -------------------------------------------------------
      FILE FINAL VALUES — USE NEW FILE OR KEEP OLD FILE
     ------------------------------------------------------- */

    const photoBase64Final = (typeof photoFile !== "undefined" && photoFile)
      ? await convertToBase64(photoFile)
      : (typeof photoBase64 !== "undefined" ? photoBase64 : "");

    const signBase64Final = (typeof signFile !== "undefined" && signFile)
      ? await convertToBase64(signFile)
      : (typeof signBase64 !== "undefined" ? signBase64 : "");

    const casteBase64Final = (typeof casteFile !== "undefined" && casteFile)
      ? await convertToBase64(casteFile)
      : (typeof casteBase64 !== "undefined" ? casteBase64 : "");

    const divyangBase64Final = (typeof divyangFile !== "undefined" && divyangFile)
      ? await convertToBase64(divyangFile)
      : (typeof divyangBase64 !== "undefined" ? divyangBase64 : "");

    // Old file names from backend API
    const oldPhotoName = candidateData?.studenT_PHOTOGRAPH || "";
    const oldSignName = candidateData?.studenT_SIGNATURE || "";
    const oldcasteFile = candidateData?.castE_CERTIFICATE || "";
    let divyangNameFinal;

    /* FILE NAMES (IF NEW FILE → NEW NAME, ELSE OLD NAME) */
    const studentPhotoName = (typeof photoFile !== "undefined" && photoFile) ? (typeof photoName !== "undefined" ? photoName : "") : oldPhotoName;
    const studentSignName = (typeof signFile !== "undefined" && signFile) ? (typeof signName !== "undefined" ? signName : "") : oldSignName;

    if (formData.divyang_val === "DIV_001") {
      divyangNameFinal = "";
    } else {
      divyangNameFinal = (typeof divyangFile !== "undefined" && divyangFile) ? (typeof divyangName !== "undefined" ? divyangName : "") : (typeof olddivyangFile !== "undefined" ? olddivyangFile : "");
    }
    const casteNameFinal = (typeof casteFile !== "undefined" && casteFile) ? (typeof casteName !== "undefined" ? casteName : "") : oldcasteFile;

    /* -------------------------------------------------------
      FORM DATA BUILD
     ------------------------------------------------------- */

    const fd = new FormData();

    // ===============================
    // CANDIDATE DETAILS
    // ===============================
    fd.append("candidatE_CODE", candidateData?.candidatE_ID || candidateData?.candidatE_CODE || "");
    fd.append("candidatE_NAME", formData.candidate_name || "");
    fd.append("dob", formData.date_of_birth || "");
    fd.append("fatheR_NAME", formData.fathers_name || "");
    fd.append("motheR_NAME", formData.mothers_name || "");
    fd.append("religion", formData.religion || "");
    fd.append("divyang", formData.divyang_val || "");
    // fd.append("mediuM_OF_EXAM", candidateData?.mediuM_OF_EXAM || "");
    fd.append("apaaR_ID", formData.apaar_id || "");
    fd.append("peN_NO", formData.pen_no || "");
    // fd.append("CASTE_CATEGORY", formData.caste_val || "");
    fd.append("DIVYANG_CATEGORY", formData.divyang_val || "");
    fd.append("SCHOOL_DIST", candidateData?.schooL_DISTRICT || "");
    fd.append("schooL_CODE", candidateData?.schooL_CODE || "");
    fd.append("REGISTRATION_NO", candidateData?.refferencE_NO || "");

    // ===============================
    // FILE NAMES
    // ===============================
    fd.append("STUDENT_PHOTOGRAPH", studentPhotoName || "");
    fd.append("STUDENT_SIGNATURE", studentSignName || "");
    fd.append("DIVYANG_CERTIFICATE", divyangNameFinal || "");

    if (typeof photoFile !== "undefined" && photoFile) {
      fd.append("STUDENT_PHOTOGRAPH_FILE", photoFile);
    }

    if (typeof signFile !== "undefined" && signFile) {
      fd.append("STUDENT_SIGNATURE_FILE", signFile);
    }

    if (typeof divyangFile !== "undefined" && divyangFile) {
      fd.append("DIVYANG_CERTIFICATE_FILE", divyangFile);
    }

    fd.append("STUDENT_PHOTOGRAPH_CHANGE_STS", PHOTO_CHANGE || "");
    fd.append("STUDENT_SIGNATURE_CHANGE_STS", SIGN_CHANGE || "");
    fd.append("DIVYANG_CERTIFICATE_CHANGE_STS", DIVYANG_CHANGE || "");

    fd.append("UPDATE_BY", sessionStorage.getItem("schoolCode") || "");
    fd.append("STREAM", formData.faculty || formData.stream || "");
    fd.append(
      "STUDENT_EXAM_CATEGORY_DESCRIPTION",
      formData.category_choice || ""
    );

    // ===============================
    // SUBJECT DETAILS
    // ===============================

    const currentStream = formData.faculty || formData.stream || "";
    if (currentStream === "SCIENCE" || currentStream === "COMMERCE") {
      // Subject 1A
      fd.append("subjecT_1_A_TYPE", "CL");

      fd.append(
        "subjecT_1_A_CODE",
        formData.category_choice === "REGULAR" ||
          formData.category_choice === "PRIVATE"
          ? formData.coresubject || ""
          : ""
      );
      // Subject 1B
      fd.append("subjecT_1_B_TYPE", "MB");
      fd.append(
        "subjecT_1_B_CODE",
        formData.category_choice === "REGULAR" ||
          formData.category_choice === "PRIVATE"
          ? formData.matribhasa || ""
          : ""
      );

      // Subject 2
      fd.append("subjecT_2_TYPE", "C1");
      fd.append(
        "subjecT_2_CODE",
        formData.category_choice === "REGULAR" ||
          formData.category_choice === "PRIVATE"
          ? formData.compulsory_one_code || formData.compulsory_one || ""
          : ""
      );

      // Subject 3
      fd.append("subjecT_3_TYPE", "C2");
      fd.append(
        "subjecT_3_CODE",
        formData.category_choice === "REGULAR" ||
          formData.category_choice === "PRIVATE"
          ? formData.compulsory_two_code || formData.compulsory_two || ""
          : ""
      );

      // Subject 4
      fd.append("subjecT_4_TYPE", "O1");
      fd.append(
        "subjecT_4_CODE",
        formData.category_choice === "REGULAR" ||
          formData.category_choice === "PRIVATE"
          ? optional1 || ""
          : ""
      );

      // Subject 5
      fd.append("subjecT_5_TYPE", "O2");
      fd.append(
        "subjecT_5_CODE",
        formData.category_choice === "REGULAR" ||
          formData.category_choice === "PRIVATE"
          ? optional2 || ""
          : ""
      );

      // Subject 6
      fd.append("subjecT_6_TYPE", "AL");
      fd.append(
        "subjecT_6_CODE",
        formData.category_choice === "REGULAR" ||
          formData.category_choice === "PRIVATE"
          ? formData.additionalsubject || ""
          : ""
      );
    } else if (currentStream === "ARTS") {
      // Subject 1A
      fd.append("subjecT_1_A_TYPE", "CL");
      fd.append(
        "subjecT_1_A_CODE",
        formData.category_choice === "REGULAR" ||
          formData.category_choice === "PRIVATE"
          ? formData.coresubject || ""
          : ""
      );

      // Subject 1B
      fd.append("subjecT_1_B_TYPE", "MB");
      fd.append(
        "subjecT_1_B_CODE",
        formData.category_choice === "REGULAR" ||
          formData.category_choice === "PRIVATE"
          ? formData.matribhasa || ""
          : ""
      );

      // Subject 2
      fd.append("subjecT_2_TYPE", "EL");
      fd.append(
        "subjecT_2_CODE",
        formData.category_choice === "REGULAR" ||
          formData.category_choice === "PRIVATE"
          ? artselective || ""
          : ""
      );

      // Subject 3
      fd.append("subjecT_3_TYPE", "O1");
      fd.append(
        "subjecT_3_CODE",
        formData.category_choice === "REGULAR" ||
          formData.category_choice === "PRIVATE"
          ? selectedArtsSubjects.arts_optional_one || ""
          : ""
      );
      // Subject 4
      fd.append("subjecT_4_TYPE", "O2");
      fd.append(
        "subjecT_4_CODE",
        formData.category_choice === "REGULAR" ||
          formData.category_choice === "PRIVATE"
          ? selectedArtsSubjects.arts_optional_two || ""
          : ""
      );

      // Subject 5
      fd.append("subjecT_5_TYPE", "O3");
      fd.append(
        "subjecT_5_CODE",
        formData.category_choice === "REGULAR" ||
          formData.category_choice === "PRIVATE"
          ? selectedArtsSubjects.arts_optional_three || ""
          : ""
      );

      // Subject 6
      fd.append("subjecT_6_TYPE", "AL");
      fd.append(
        "subjecT_6_CODE",
        formData.category_choice === "REGULAR" ||
          formData.category_choice === "PRIVATE"
          ? formData.additionalsubject || ""
          : ""
      );
    }

    /* -------------------------------------------------------
      API CALL
     ------------------------------------------------------- */

    try {
      setLoading(true);
      const response = await fetch(
        `${config.API_BASE_URL2}/AdminDemographySubjectChange_CL12`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: fd,
        }
      );

      const data = await response.json();
      setLoading(false);

      if (response.ok) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: "Your data added successfully",
        });

        navigate("/intermediate-demographic-details-update");
      } else {
        await Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: data.message || "Something went wrong.",
        });
      }
    } catch (error) {
      setLoading(false);
      console.error("API Error:", error);
      await Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "Please check your internet connection.",
      });
    }
  };

  const handlePenBlur = async () => {
    const rawPen = formData.pen_no?.trim();
    if (rawPen) {
      const penno = rawPen.replace(/\s/g, "");

      if (!penno || penno.length < 11 || penno.length > 14) return;

      const token =
        sessionStorage.getItem("intermediateAdminToken") ||
        sessionStorage.getItem("tokenclassxi");

      try {
        const response = await fetch(
          `${config.API_BASE_URL2}/PENNoCheckingStudentData_CL12`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              candidatE_ID: candidateData?.candidatE_ID || class11candidateid || "",
              peN_NO: penno,
            }),
          }
        );

        const result = await response.json();

        if (result.status === 404) {
          Swal.fire({
            icon: "warning",
            title: "PEN(Permanent Education Number) No. Already Exists.",
          });
          setFormData((prev) => ({
            ...prev,
            pen_no: "",
          }));

          return;
        }
      } catch (error) {
        console.error("Error verifying PEN No.", error);
      }
    }
  };

  // Convert "dd-MM-yyyy" → JS Date safely
  const parseDate = (dateStr) => {
    if (!dateStr) return null;

    const [dd, mm, yyyy] = dateStr.split("-");
    return new Date(Number(yyyy), Number(mm) - 1, Number(dd));
  };

  const formatDateForApi = (date) => {
    if (!date) return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleChangeDate = (date) => {
    if (date) {
      const dd = String(date.getDate()).padStart(2, "0");
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const yyyy = date.getFullYear();

      setFormData((prev) => ({
        ...prev,
        date_of_birth: `${dd}-${mm}-${yyyy}`,
      }));
    } else {
      setFormData((prev) => ({ ...prev, date_of_birth: "" }));
    }
  };
  useEffect(() => {
    setSelectedSubjectNames((prev) => ({
      ...prev,
      additionalsubject: "",
    }));
  }, [formData.coresubject]);
  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <div class="container-scroller">
        <Navbar />
        <div class="container-fluid page-body-wrapper">
          <Sidebar />
          {loading && (
            <div className="custom-loader-container">
              <div className="custom-loader"></div>
            </div>
          )}
          <div class="main-panel">
            <div class="content-wrapper">
              <div class="row">
                <div class="col-md-12 mb-1">
                  <section class="content-header ">
                    <h1>
                      <i class="fa fa-user-plus"></i>&nbsp; Student Demographic Details Correction for Class XII [ACCOUNT APPROVED]
                    </h1>
                    <ol class="breadcrumb">
                      <li>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/class-xi-dashboard");
                          }}
                        >
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            stroke-width="0"
                            viewBox="0 0 512 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginTop: "-4px" }}
                          >
                            <path d="M256 64C132.3 64 32 164.2 32 287.9c0 57 21.3 109 56.3 148.5 1.1 1.2 2.1 2.4 3.2 3.5C96.3 445 103 448 110 448c7.1 0 13.8-3 18.6-8.2 31.6-34.4 77-55.9 127.4-55.9s95.8 21.6 127.4 55.9c4.8 5.2 11.5 8.2 18.6 8.2 7 0 13.7-2.9 18.5-8.1 1.1-1.2 2.1-2.3 3.2-3.5 35-39.5 56.3-91.5 56.3-148.5C480 164.2 379.7 64 256 64zm-14 45.9c0-7.7 6.3-14 14-14s14 6.3 14 14v36c0 7.7-6.3 14-14 14s-14-6.3-14-14v-36zm-128 192H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm51.5-104.5c-5.4 5.4-14.4 5.4-19.8 0L120.2 172c-5.4-5.4-5.4-14.4 0-19.8s14.4-5.4 19.8 0l25.5 25.5c5.4 5.4 5.4 14.3 0 19.7zm160.6 34.5l-47.5 75.5c-1.9 2.6-4.3 5.1-7 7-13.5 9.7-32.3 6.5-42-7s-6.5-32.3 7-42l75.5-47.5c3.4-2.4 8.1-2.5 11.7 0 4.5 3.2 5.5 9.5 2.3 14zm40.2-34.5c-5.4 5.4-14.4 5.4-19.8 0s-5.4-14.4 0-19.8l25.5-25.5c5.4-5.4 14.4-5.4 19.8 0s5.4 14.4 0 19.8l-25.5 25.5zM434 301.9h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"></path>
                          </svg>{" "}
                          Home&nbsp;
                        </a>
                      </li>
                      <li class="active"> Add Student (JAC)</li>
                    </ol>
                  </section>
                </div>
              </div>
              <div class="row">

                <div class="col-lg-12 mb-4">
                  <div class="card">
                    <div class="card-header card-green">
                      <h4 class="mb-0 p-2">Student Details</h4>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div
                          class="col-lg-9"
                          style={{ borderRight: "1px solid #CED4DA" }}
                        >
                          <div class="row">
                            <div class="col-lg-6 col-m-6">
                              <div class="form-group  mb-3">
                                <label>
                                  Name of Student{" "}
                                  <span class="text-danger">*</span>
                                </label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    name="candidate_name"
                                    maxlength="35"
                                    className={`form-control form-control-sm ${errors.candidate_name ? "is-invalid" : ""
                                      }`}
                                    placeholder="Candidate Name"
                                    value={formData.candidate_name || ""}
                                    onChange={handleChange}
                                    disabled={isPreviewed}
                                  />
                                </div>
                                {errors.candidate_name && (
                                  <div className="text-danger mt-1 small">
                                    {errors.candidate_name}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>
                                  Gender <span class="text-danger">*</span>
                                </label>
                                <select
                                  className={`form-select form-control-sm disable ${errors.gender ? "is-invalid" : ""
                                    }`}
                                  value={formData.gender || ""}
                                  name="gender"
                                  onChange={handleChange}
                                  class="form-select form-control"
                                  disabled={genderDisabled || isPreviewed}
                                >
                                  <option value="">Select</option>
                                  <option value="MALE">MALE</option>
                                  <option value="FEMALE">FEMALE</option>
                                  <option value="TRANSGENDER">
                                    TRANSGENDER
                                  </option>
                                </select>
                                {errors.gender && (
                                  <div className="text-danger mt-1 small">
                                    {errors.gender}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>
                                  Date of Birth{" "}
                                  <span class="text-danger">*</span>
                                </label>
                                <DatePicker
                                  minDate={new Date(1975, 0, 1)}
                                  maxDate={new Date(2011, 2, 1)}
                                  selected={
                                    formData.date_of_birth
                                      ? (() => {
                                        const [dd, mm, yyyy] =
                                          formData.date_of_birth.split("-");
                                        return new Date(
                                          Number(yyyy),
                                          Number(mm) - 1,
                                          Number(dd)
                                        );
                                      })()
                                      : null
                                  }
                                  onChange={handleChangeDate}
                                  dateFormat="dd-MM-yyyy"
                                  className={`form-control form-control-sm ${errors.date_of_birth ? "is-invalid" : ""
                                    }`}
                                  placeholderText="dd-mm-yyyy"
                                  disabled={isPreviewed}
                                  onKeyDown={(e) => e.preventDefault()}
                                  showYearDropdown
                                  scrollableYearDropdown
                                  yearDropdownItemNumber={60}
                                />
                                {errors.date_of_birth && (
                                  <div className="text-danger mt-1 small">
                                    {errors.date_of_birth}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div class="col-lg-6 col-md-6">
                              <div class="form-group  mb-3">
                                <label>
                                  Father’s Name
                                  <span class="text-danger">*</span>
                                </label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    name="fathers_name"
                                    className={`form-control form-control-sm ${errors.fathers_name ? "is-invalid" : ""
                                      }`}
                                    value={formData.fathers_name || ""}
                                    maxlength="35"
                                    placeholder="Father’s Name"
                                    onChange={handleChange}
                                    disabled={isPreviewed}
                                    onBlur={(e) =>
                                      setFormData((prev) => ({
                                        ...prev,
                                        fathers_name: e.target.value
                                          .trim()
                                          .replace(/\s+/g, " "),
                                      }))
                                    }
                                  />
                                </div>
                                {errors.fathers_name && (
                                  <div className="text-danger mt-1 small">
                                    {errors.fathers_name}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div class="col-lg-6 col-md-6">
                              <div class="form-group  mb-3">
                                <label>
                                  Mother’s Name{" "}
                                  <span class="text-danger">*</span>
                                </label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    name="mothers_name"
                                    onChange={handleChange}
                                    className={`form-control form-control-sm ${errors.mothers_name ? "is-invalid" : ""
                                      }`}
                                    value={formData.mothers_name || ""}
                                    maxlength="35"
                                    placeholder="Mother’s Name"
                                    disabled={isPreviewed}
                                    onBlur={(e) =>
                                      setFormData((prev) => ({
                                        ...prev,
                                        mothers_name: e.target.value
                                          .trim()
                                          .replace(/\s+/g, " "),
                                      }))
                                    }
                                  />
                                </div>
                                {errors.mothers_name && (
                                  <div className="text-danger mt-1 small">
                                    {errors.mothers_name}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>
                                  Religion <span class="text-danger">*</span>
                                </label>
                                <select
                                  className={`form-select form-control-sm ${errors.religion ? "is-invalid" : ""
                                    }`}
                                  name="religion"
                                  id="religion"
                                  value={formData.religion || ""}
                                  onChange={handleChange}
                                  disabled={isPreviewed}
                                >
                                  <option value="">Choose Religion</option>
                                  {religionList.map((religion) => (
                                    <option
                                      key={religion.religioN_ID}
                                      value={religion.religioN_ID}
                                    >
                                      {religion.religioN_NAME}
                                    </option>
                                  ))}
                                </select>
                                {errors.religion && (
                                  <div className="text-danger mt-1 small">
                                    {errors.religion}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>Nationality</label>
                                <select
                                  class="form-select form-control disable"
                                  id="nationality"
                                  disabled
                                >
                                  <option value="Indian" selected="">
                                    Indian
                                  </option>
                                </select>
                              </div>
                            </div>

                          </div>
                        </div>
                        <div class="col-lg-3 col-md-12">
                          <div class="form-group mb-3">
                            <label>
                              Divyang <span class="text-danger">*</span>
                            </label>
                            <select
                              className={`form-select form-control-sm ${errors.divyang_val ? "is-invalid" : ""
                                }`}
                              id="divyang_val"
                              name="divyang_val"
                              value={formData.divyang_val}
                              onChange={handleChange}
                              disabled={isPreviewed}
                            >
                              <option value="">Select</option>
                              {divyangList.map((divyang) => (
                                <option
                                  key={divyang.divyanG_ID}
                                  value={divyang.divyanG_ID}
                                >
                                  {divyang.divyanG_NAME}
                                </option>
                              ))}
                            </select>
                            {errors.divyang_val && (
                              <div className="text-danger mt-1 small">
                                {errors.divyang_val}
                              </div>
                            )}
                          </div>
                          <div class="form-group mb-3">
                            <label>
                              Caste <span class="text-danger">*</span>
                            </label>
                            <select
                              className={`form-select form-control-sm caste ${errors.caste_val ? "is-invalid" : ""
                                }`}
                              name="caste_val"
                              id="caste_val"
                              value={formData.caste_val}
                              onChange={handleChange}
                              disabled={true}
                            >
                              <option value="">Choose Caste</option>
                              {casteList.map((caste) => (
                                <option
                                  key={caste.castE_ID}
                                  value={caste.castE_ID}
                                >
                                  {caste.castE_NAME}
                                </option>
                              ))}
                            </select>
                            {errors.caste_val && (
                              <div className="text-danger mt-1 small">
                                {errors.caste_val}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={formData.category_choice === "EX-REGULAR" ? "col-lg-12 col-m-12 mb-4 stretch-card" : "col-lg-9 col-m-12 mb-4 stretch-card"}>
                  <div class="card">
                    <div class="card-header card-green">
                      <h4 class="mb-0 p-2">Educational Details</h4>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="form-group">
                          <div class="row">
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>
                                  Category Choice{" "}
                                  <span class="text-danger">*</span>
                                </label>
                                <input
                                  disabled={true}
                                  class="form-control form-control-sm"
                                  id="category_choice"
                                  name="category_choice"
                                  value={candidateData.studenT_EXAM_CATEGORY_DESCRIPTION === "BETTERMENT" ? "IMPROVEMENT" : candidateData.studenT_EXAM_CATEGORY_DESCRIPTION}


                                />
                              </div>
                            </div>
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>
                                  Board Name<span class="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  value={candidateData.boarD_NAME}
                                />
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div className="form-group mb-3">
                                <label>
                                  Stream <span className="text-danger">*</span>
                                </label>
                                <input
                                  className={`form-control form-control-sm  ${errors.stream ? "is-invalid" : ""
                                    }`}
                                  name="stream"
                                  id="stream"
                                  value={candidateData.stream}
                                  disabled={true}

                                />

                              </div>
                            </div>
                          </div>
                          {formData.stream && (
                            <div class="row">
                              <div class="col-md-12 mb-3">
                                <h4>Core Subjects</h4>
                                <hr />
                                <div class="row">
                                  <div class="col-md-4">
                                    <div class="form-group mb-3">
                                      <label>
                                        Core Language{" "}
                                        <span class="text-danger">*</span>
                                      </label>
                                      <select
                                        id="coresubject"
                                        className={`form-select  ${errors.coresubject ? "is-invalid" : ""
                                          }`}
                                        disabled={
                                          isPreviewed ||
                                          !["REGULAR", "PRIVATE"].includes(formData.category_choice)
                                        }
                                        name="coresubject"
                                        value={formData.coresubject || ""}
                                        onChange={(e) => {
                                          handleChange(e);
                                          const selectedText =
                                            e.target.options[
                                              e.target.selectedIndex
                                            ].text;
                                          setSelectedSubjectNames((prev) => ({
                                            ...prev,
                                            coresubject: selectedText,
                                          }));
                                          const selectedValue = e.target.value;
                                          if (
                                            selectedValue === "ENA" ||
                                            selectedValue === "HNA"
                                          ) {
                                            setFormData((prev) => ({
                                              ...prev,
                                              matribhasa: "",
                                            }));
                                            setSelectedSubjectNames((prev) => ({
                                              ...prev,
                                              matribhasa: "",
                                            }));
                                          }
                                        }}
                                      >
                                        <option value="">Choose Subject</option>
                                        {coresubject
                                          .filter((subject) => {
                                            const selectedIds = [
                                              formData.matribhasa,
                                              formData.compulsory_one,
                                              formData.compulsory_two,
                                              formData.additionalsubject,
                                              selectedArtsSubjects.arts_optional_one,
                                              selectedArtsSubjects.arts_optional_two,
                                              selectedArtsSubjects.arts_optional_three,
                                              optional1,
                                              optional2,
                                              artselective,
                                            ];
                                            const selectedNames =
                                              Object.values(
                                                selectedSubjectNames
                                              );
                                            return (
                                              subject.subjecT_ID ===
                                              formData.coresubject || // ✅ Keep current selection
                                              (!selectedIds.includes(
                                                subject.subjecT_ID
                                              ) &&
                                                !selectedNames.includes(
                                                  subject.subjecT_NAME
                                                ))
                                            );
                                          })
                                          .map((subject) => (
                                            <option
                                              key={subject.subjecT_ID}
                                              value={subject.subjecT_ID}
                                            >
                                              {subject.subjecT_NAME}
                                            </option>
                                          ))}
                                      </select>
                                      {errors.coresubject && (
                                        <div className="text-danger mt-1 small">
                                          {errors.coresubject}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <div class="form-group mb-3">
                                      <label>
                                        Matri Bhasa{" "}
                                        <span class="text-danger">*</span>
                                      </label>
                                      <select
                                        id="matribhasa"
                                        className={`form-select  ${errors.matribhasa ? "is-invalid" : ""
                                          }`}
                                        name="matribhasa"
                                        value={formData.matribhasa || ""}
                                        onChange={(e) => {
                                          handleChange(e);
                                          const selectedText =
                                            e.target.options[
                                              e.target.selectedIndex
                                            ].text;
                                          setSelectedSubjectNames((prev) => ({
                                            ...prev,
                                            matribhasa: selectedText,
                                          }));
                                        }}
                                        disabled={
                                          formData.coresubject === "ENA" ||
                                          formData.coresubject === "HNA" ||
                                          isPreviewed ||
                                          !["REGULAR", "PRIVATE"].includes(formData.category_choice)
                                        }
                                      >
                                        <option value="">Choose Subject</option>
                                        {matribhasa
                                          .filter((subject) => {
                                            const selectedIds = [
                                              formData.coresubject,
                                              formData.compulsory_one,
                                              formData.compulsory_two,
                                              formData.additionalsubject,
                                              selectedArtsSubjects.arts_optional_one,
                                              selectedArtsSubjects.arts_optional_two,
                                              selectedArtsSubjects.arts_optional_three,
                                              optional1,
                                              optional2,
                                              artselective,
                                            ];
                                            const selectedNames =
                                              Object.values(
                                                selectedSubjectNames
                                              );
                                            return (
                                              subject.subjecT_ID ===
                                              formData.matribhasa || // ✅ Keep current selection
                                              (!selectedIds.includes(
                                                subject.subjecT_ID
                                              ) &&
                                                !selectedNames.includes(
                                                  subject.subjecT_NAME
                                                ))
                                            );
                                          })
                                          .map((subject) => (
                                            <option
                                              key={subject.subjecT_ID}
                                              value={subject.subjecT_ID}
                                            >
                                              {subject.subjecT_NAME}
                                            </option>
                                          ))}
                                      </select>
                                      {errors.matribhasa && (
                                        <div className="text-danger mt-1 small">
                                          {errors.matribhasa}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {formData.stream === "SCIENCE" && (
                                <>
                                  <div
                                    class="col-md-12 mb-3"
                                    id="science_paper2"
                                  >
                                    <h4>Compulsory Subjects</h4>
                                    <hr />
                                    <div class="row">
                                      <div className="col-md-4">
                                        <div className="form-group mb-3">
                                          <label>
                                            Compulsory 1{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            value={compulsoryonename}
                                            disabled
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group mb-3">
                                          <label>
                                            Compulsory 2{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            value={compulsorytwoname}
                                            disabled
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div
                                    class="col-md-12 mb-3"
                                    id="science_paper3"
                                  >
                                    <h4>Optional Subjects</h4>
                                    <hr />
                                    <div class="row">
                                      <div class="col-md-4">
                                        <div class="form-group mb-3">
                                          <label>
                                            Optional 1{" "}
                                            <span class="text-danger">*</span>
                                          </label>
                                          <select
                                            className={`form-select ${errors.sc_optional_one
                                              ? "is-invalid"
                                              : ""
                                              }`}
                                            disabled={isPreviewed || !["REGULAR", "PRIVATE"].includes(formData.category_choice)}
                                            id="sc_optional_one"
                                            name="sc_optional_one"
                                            value={optional1}
                                            onChange={(e) => {
                                              setOptional1(e.target.value);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;

                                              // Update name state
                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  optional1: selectedText,
                                                })
                                              );
                                            }}
                                          >
                                            <option value="">
                                              Choose Subject
                                            </option>
                                            {optionalfiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  formData.additionalsubject,
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  optional2,
                                                  artselective,
                                                ];

                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames
                                                  );

                                                const vocationalSelected =
                                                  (optional2 &&
                                                    optionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        optional2 &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (formData.additionalsubject &&
                                                    optionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        formData.additionalsubject &&
                                                        s.vocational === "YES"
                                                    ));

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                  "YES" &&
                                                  subject.subjecT_ID !==
                                                  optional1
                                                ) {
                                                  return false; // hide all vocational except the one already chosen
                                                }

                                                // ✅ Science stream condition
                                                if (
                                                  formData.stream === "SCIENCE"
                                                ) {
                                                  // If Optional 2 or Additional subject is MAT, remove STA here
                                                  if (
                                                    (optional2 === "MAT" ||
                                                      formData.additionalsubject ===
                                                      "MAT") &&
                                                    subject.subjecT_ID === "STA"
                                                  ) {
                                                    return false;
                                                  }
                                                  // If Optional 2 or Additional subject is STA, remove MAT here
                                                  if (
                                                    (optional2 === "STA" ||
                                                      formData.additionalsubject ===
                                                      "STA") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Commerce stream condition
                                                if (
                                                  formData.stream === "COMMERCE"
                                                ) {
                                                  // If Optional 2 or Additional subject is MAT, remove CAE
                                                  if (
                                                    (optional2 === "MAT" ||
                                                      formData.additionalsubject ===
                                                      "MAT") &&
                                                    subject.subjecT_ID === "CAE"
                                                  ) {
                                                    return false;
                                                  }
                                                  // If Optional 2 or Additional subject is CAE, remove MAT
                                                  if (
                                                    (optional2 === "CAE" ||
                                                      formData.additionalsubject ===
                                                      "CAE") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Keep current selection OR allow only unselected subjects
                                                return (
                                                  subject.subjecT_ID ===
                                                  optional1 ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>

                                          {errors.sc_optional_one && (
                                            <div className="text-danger mt-1 small">
                                              {errors.sc_optional_one}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group mb-3">
                                          <label>
                                            Optional 2{" "}
                                            <span class="text-danger">*</span>
                                          </label>
                                          <select
                                            disabled={isPreviewed || !["REGULAR", "PRIVATE"].includes(formData.category_choice)}
                                            className={`form-select ${errors.sc_optional_two
                                              ? "is-invalid"
                                              : ""
                                              }`}
                                            id="sc_optional_two"
                                            name="sc_optional_two"
                                            value={optional2}
                                            onChange={(e) => {
                                              setOptional2(e.target.value);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;

                                              // Update name state
                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  optional2: selectedText,
                                                })
                                              );
                                            }}
                                          >
                                            <option value="">
                                              Choose Subject
                                            </option>
                                            {optionalfiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  formData.additionalsubject,
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  optional1,
                                                  artselective,
                                                ];

                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames
                                                  );

                                                const vocationalSelected =
                                                  (optional1 &&
                                                    optionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        optional1 &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (formData.additionalsubject &&
                                                    optionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        formData.additionalsubject &&
                                                        s.vocational === "YES"
                                                    ));

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                  "YES" &&
                                                  subject.subjecT_ID !==
                                                  optional2
                                                ) {
                                                  return false; // hide all vocational except the one already chosen
                                                }

                                                // ✅ Science stream condition
                                                if (
                                                  formData.stream === "SCIENCE"
                                                ) {
                                                  if (
                                                    (optional1 === "MAT" ||
                                                      formData.additionalsubject ===
                                                      "MAT") &&
                                                    subject.subjecT_ID === "STA"
                                                  ) {
                                                    return false;
                                                  }
                                                  if (
                                                    (optional1 === "STA" ||
                                                      formData.additionalsubject ===
                                                      "STA") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Commerce stream condition
                                                if (
                                                  formData.stream === "COMMERCE"
                                                ) {
                                                  if (
                                                    (optional1 === "MAT" ||
                                                      formData.additionalsubject ===
                                                      "MAT") &&
                                                    subject.subjecT_ID === "CAE"
                                                  ) {
                                                    return false;
                                                  }
                                                  if (
                                                    (optional1 === "CAE" ||
                                                      formData.additionalsubject ===
                                                      "CAE") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Keep current selection OR allow only unselected subjects
                                                return (
                                                  subject.subjecT_ID ===
                                                  optional2 ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>

                                          {errors.sc_optional_two && (
                                            <div className="text-danger mt-1 small">
                                              {errors.sc_optional_two}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div
                                    class="col-md-12"
                                    id="science_additional"
                                  >
                                    <h4>Additional Subject </h4>
                                    <hr />
                                    <div class="row">
                                      <div className="col-md-4 mb-2">
                                        <div className="form-group mb-3">
                                          <select
                                            disabled={isPreviewed || !["REGULAR", "PRIVATE"].includes(formData.category_choice)}
                                            className="form-select"
                                            id="additionalsubject"
                                            name="additionalsubject"
                                            value={
                                              formData.additionalsubject || ""
                                            }
                                            onChange={(e) => {
                                              handleChange(e);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;

                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  additionalsubject:
                                                    selectedText,
                                                })
                                              );
                                            }}
                                          >
                                            <option value="">
                                              Choose Subject
                                            </option>
                                            {additionalfiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  optional1,
                                                  optional2,
                                                  artselective,
                                                ];

                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames
                                                  );

                                                const vocationalSelected =
                                                  (optional1 &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        optional1 &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (optional2 &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        optional2 &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_one &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        selectedArtsSubjects.arts_optional_one &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_two &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        selectedArtsSubjects.arts_optional_two &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_three &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        selectedArtsSubjects.arts_optional_three &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (artselective &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        artselective &&
                                                        s.vocational === "YES"
                                                    ));

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                  "YES" &&
                                                  subject.subjecT_ID !==
                                                  formData.additionalsubject
                                                ) {
                                                  return false; // hide all vocational except the one already chosen
                                                }
                                                // ✅ Language-based restrictions
                                                if (
                                                  formData.coresubject ===
                                                  "HNA" &&
                                                  subject.subjecT_ID === "HIN"
                                                ) {
                                                  return false;
                                                }
                                                if (
                                                  formData.coresubject ===
                                                  "ENA" &&
                                                  (subject.subjecT_ID ===
                                                    "ENG" ||
                                                    subject.subjecT_ID ===
                                                    "FEN")
                                                ) {
                                                  return false;
                                                }

                                                // ✅ Science stream restrictions
                                                if (
                                                  formData.stream === "SCIENCE"
                                                ) {
                                                  if (
                                                    (optional1 === "MAT" ||
                                                      optional2 === "MAT") &&
                                                    subject.subjecT_ID === "STA"
                                                  ) {
                                                    return false;
                                                  }
                                                  if (
                                                    (optional1 === "STA" ||
                                                      optional2 === "STA") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Commerce stream restrictions
                                                if (
                                                  formData.stream === "COMMERCE"
                                                ) {
                                                  if (
                                                    (optional1 === "MAT" ||
                                                      optional2 === "MAT") &&
                                                    subject.subjecT_ID === "CAE"
                                                  ) {
                                                    return false;
                                                  }
                                                  if (
                                                    (optional1 === "CAE" ||
                                                      optional2 === "CAE") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Arts stream MAT/STA restrictions
                                                if (
                                                  formData.stream === "ARTS"
                                                ) {
                                                  const {
                                                    arts_optional_one,
                                                    arts_optional_two,
                                                    arts_optional_three,
                                                  } = selectedArtsSubjects;

                                                  // If MAT selected anywhere, remove both MAT & STA
                                                  if (
                                                    arts_optional_one ===
                                                    "MAT" ||
                                                    arts_optional_two ===
                                                    "MAT" ||
                                                    arts_optional_three ===
                                                    "MAT"
                                                  ) {
                                                    if (
                                                      subject.subjecT_ID ===
                                                      "MAT" ||
                                                      subject.subjecT_ID ===
                                                      "STA"
                                                    ) {
                                                      return false;
                                                    }
                                                  }

                                                  // If STA selected anywhere, remove both STA & MAT
                                                  if (
                                                    arts_optional_one ===
                                                    "STA" ||
                                                    arts_optional_two ===
                                                    "STA" ||
                                                    arts_optional_three ===
                                                    "STA"
                                                  ) {
                                                    if (
                                                      subject.subjecT_ID ===
                                                      "STA" ||
                                                      subject.subjecT_ID ===
                                                      "MAT"
                                                    ) {
                                                      return false;
                                                    }
                                                  }
                                                }

                                                // ✅ Keep current selection OR allow unselected subjects
                                                return (
                                                  subject.subjecT_ID ===
                                                  formData.additionalsubject ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                              {formData.stream === "COMMERCE" && (
                                <>
                                  <div
                                    class="col-md-12 mb-3"
                                    id="commerce_paper2"
                                  >
                                    <h4>Compulsory Subjects</h4>
                                    <hr />
                                    <div class="row">
                                      <div className="col-md-4">
                                        <div className="form-group mb-3">
                                          <label>
                                            Compulsory 1{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            value={compulsoryonename}
                                            disabled
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group mb-3">
                                          <label>
                                            Compulsory 2{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            value={compulsorytwoname}
                                            disabled
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div
                                    class="col-md-12 mb-3"
                                    id="commerce_paper3"
                                  >
                                    <h4>Optional Subjects</h4>
                                    <hr />
                                    <div class="row">
                                      <div class="col-md-4">
                                        <div class="form-group mb-3">
                                          <label>
                                            Optional 1{" "}
                                            <span class="text-danger">*</span>
                                          </label>
                                          <select
                                            className={`form-select ${errors.sc_optional_one
                                              ? "is-invalid"
                                              : ""
                                              }`}
                                            disabled={isPreviewed || !["REGULAR", "PRIVATE"].includes(formData.category_choice)}
                                            id="sc_optional_one"
                                            name="sc_optional_one"
                                            value={optional1}
                                            onChange={(e) => {
                                              setOptional1(e.target.value);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;

                                              // Update name state
                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  optional1: selectedText,
                                                })
                                              );
                                            }}
                                          >
                                            <option value="">
                                              Choose Subject
                                            </option>
                                            {optionalfiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  formData.additionalsubject,
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  optional2,
                                                  artselective,
                                                ];

                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames
                                                  );

                                                const vocationalSelected =
                                                  (optional2 &&
                                                    optionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        optional2 &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (formData.additionalsubject &&
                                                    optionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        formData.additionalsubject &&
                                                        s.vocational === "YES"
                                                    ));

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                  "YES" &&
                                                  subject.subjecT_ID !==
                                                  optional1
                                                ) {
                                                  return false; // hide all vocational except the one already chosen
                                                }

                                                // ✅ Science stream condition
                                                if (
                                                  formData.stream === "SCIENCE"
                                                ) {
                                                  // If Optional 2 or Additional subject is MAT, remove STA here
                                                  if (
                                                    (optional2 === "MAT" ||
                                                      formData.additionalsubject ===
                                                      "MAT") &&
                                                    subject.subjecT_ID === "STA"
                                                  ) {
                                                    return false;
                                                  }
                                                  // If Optional 2 or Additional subject is STA, remove MAT here
                                                  if (
                                                    (optional2 === "STA" ||
                                                      formData.additionalsubject ===
                                                      "STA") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Commerce stream condition
                                                if (
                                                  formData.stream === "COMMERCE"
                                                ) {
                                                  // If Optional 2 or Additional subject is MAT, remove CAE
                                                  if (
                                                    (optional2 === "MAT" ||
                                                      formData.additionalsubject ===
                                                      "MAT") &&
                                                    subject.subjecT_ID === "CAE"
                                                  ) {
                                                    return false;
                                                  }
                                                  // If Optional 2 or Additional subject is CAE, remove MAT
                                                  if (
                                                    (optional2 === "CAE" ||
                                                      formData.additionalsubject ===
                                                      "CAE") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Keep current selection OR allow only unselected subjects
                                                return (
                                                  subject.subjecT_ID ===
                                                  optional1 ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>

                                          {errors.sc_optional_one && (
                                            <div className="text-danger mt-1 small">
                                              {errors.sc_optional_one}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group mb-3">
                                          <label>
                                            Optional 2{" "}
                                            <span class="text-danger">*</span>
                                          </label>
                                          <select
                                            disabled={isPreviewed || !["REGULAR", "PRIVATE"].includes(formData.category_choice)}
                                            className={`form-select ${errors.sc_optional_two
                                              ? "is-invalid"
                                              : ""
                                              }`}
                                            id="sc_optional_two"
                                            name="sc_optional_two"
                                            value={optional2}
                                            onChange={(e) => {
                                              setOptional2(e.target.value);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;

                                              // Update name state
                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  optional2: selectedText,
                                                })
                                              );
                                            }}
                                          >
                                            <option value="">
                                              Choose Subject
                                            </option>
                                            {optionalfiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  formData.additionalsubject,
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  optional1,
                                                  artselective,
                                                ];

                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames
                                                  );

                                                const vocationalSelected =
                                                  (optional1 &&
                                                    optionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        optional1 &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (formData.additionalsubject &&
                                                    optionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        formData.additionalsubject &&
                                                        s.vocational === "YES"
                                                    ));

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                  "YES" &&
                                                  subject.subjecT_ID !==
                                                  optional2
                                                ) {
                                                  return false; // hide all vocational except the one already chosen
                                                }

                                                // ✅ Science stream condition
                                                if (
                                                  formData.stream === "SCIENCE"
                                                ) {
                                                  if (
                                                    (optional1 === "MAT" ||
                                                      formData.additionalsubject ===
                                                      "MAT") &&
                                                    subject.subjecT_ID === "STA"
                                                  ) {
                                                    return false;
                                                  }
                                                  if (
                                                    (optional1 === "STA" ||
                                                      formData.additionalsubject ===
                                                      "STA") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Commerce stream condition
                                                if (
                                                  formData.stream === "COMMERCE"
                                                ) {
                                                  if (
                                                    (optional1 === "MAT" ||
                                                      formData.additionalsubject ===
                                                      "MAT") &&
                                                    subject.subjecT_ID === "CAE"
                                                  ) {
                                                    return false;
                                                  }
                                                  if (
                                                    (optional1 === "CAE" ||
                                                      formData.additionalsubject ===
                                                      "CAE") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Keep current selection OR allow only unselected subjects
                                                return (
                                                  subject.subjecT_ID ===
                                                  optional2 ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>

                                          {errors.sc_optional_two && (
                                            <div className="text-danger mt-1 small">
                                              {errors.sc_optional_two}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div
                                    class="col-md-12"
                                    id="commerce_additional"
                                  >
                                    <h4>Additional Subject </h4>
                                    <hr />
                                    <div class="row">
                                      <div className="col-md-4 mb-2">
                                        <div className="form-group mb-3">
                                          <select
                                            disabled={isPreviewed || !["REGULAR", "PRIVATE"].includes(formData.category_choice)}
                                            className="form-select"
                                            id="additionalsubject"
                                            name="additionalsubject"
                                            value={
                                              formData.additionalsubject || ""
                                            }
                                            onChange={(e) => {
                                              handleChange(e);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;

                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  additionalsubject:
                                                    selectedText,
                                                })
                                              );
                                            }}
                                          >
                                            <option value="">
                                              Choose Subject
                                            </option>
                                            {additionalfiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  optional1,
                                                  optional2,
                                                  artselective,
                                                ];

                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames
                                                  );

                                                const vocationalSelected =
                                                  (optional1 &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        optional1 &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (optional2 &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        optional2 &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_one &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        selectedArtsSubjects.arts_optional_one &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_two &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        selectedArtsSubjects.arts_optional_two &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_three &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        selectedArtsSubjects.arts_optional_three &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (artselective &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        artselective &&
                                                        s.vocational === "YES"
                                                    ));

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                  "YES" &&
                                                  subject.subjecT_ID !==
                                                  formData.additionalsubject
                                                ) {
                                                  return false; // hide all vocational except the one already chosen
                                                }
                                                // ✅ Language-based restrictions
                                                if (
                                                  formData.coresubject ===
                                                  "HNA" &&
                                                  subject.subjecT_ID === "HIN"
                                                ) {
                                                  return false;
                                                }
                                                if (
                                                  formData.coresubject ===
                                                  "ENA" &&
                                                  (subject.subjecT_ID ===
                                                    "ENG" ||
                                                    subject.subjecT_ID ===
                                                    "FEN")
                                                ) {
                                                  return false;
                                                }

                                                // ✅ Science stream restrictions
                                                if (
                                                  formData.stream === "SCIENCE"
                                                ) {
                                                  if (
                                                    (optional1 === "MAT" ||
                                                      optional2 === "MAT") &&
                                                    subject.subjecT_ID === "STA"
                                                  ) {
                                                    return false;
                                                  }
                                                  if (
                                                    (optional1 === "STA" ||
                                                      optional2 === "STA") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Commerce stream restrictions
                                                if (
                                                  formData.stream === "COMMERCE"
                                                ) {
                                                  if (
                                                    (optional1 === "MAT" ||
                                                      optional2 === "MAT") &&
                                                    subject.subjecT_ID === "CAE"
                                                  ) {
                                                    return false;
                                                  }
                                                  if (
                                                    (optional1 === "CAE" ||
                                                      optional2 === "CAE") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Arts stream MAT/STA restrictions
                                                if (
                                                  formData.stream === "ARTS"
                                                ) {
                                                  const {
                                                    arts_optional_one,
                                                    arts_optional_two,
                                                    arts_optional_three,
                                                  } = selectedArtsSubjects;

                                                  // If MAT selected anywhere, remove both MAT & STA
                                                  if (
                                                    arts_optional_one ===
                                                    "MAT" ||
                                                    arts_optional_two ===
                                                    "MAT" ||
                                                    arts_optional_three ===
                                                    "MAT"
                                                  ) {
                                                    if (
                                                      subject.subjecT_ID ===
                                                      "MAT" ||
                                                      subject.subjecT_ID ===
                                                      "STA"
                                                    ) {
                                                      return false;
                                                    }
                                                  }

                                                  // If STA selected anywhere, remove both STA & MAT
                                                  if (
                                                    arts_optional_one ===
                                                    "STA" ||
                                                    arts_optional_two ===
                                                    "STA" ||
                                                    arts_optional_three ===
                                                    "STA"
                                                  ) {
                                                    if (
                                                      subject.subjecT_ID ===
                                                      "STA" ||
                                                      subject.subjecT_ID ===
                                                      "MAT"
                                                    ) {
                                                      return false;
                                                    }
                                                  }
                                                }

                                                // ✅ Keep current selection OR allow unselected subjects
                                                return (
                                                  subject.subjecT_ID ===
                                                  formData.additionalsubject ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                              {formData.stream === "ARTS" && (
                                <>
                                  <div class="col-md-12 mb-3" id="arts_paper2">
                                    <h4>Elective Subject</h4>
                                    <hr />
                                    <div class="row">
                                      <div className="col-md-4">
                                        <div className="form-group mb-3">
                                          <label>
                                            Elective Language
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <select
                                            className={`form-select ${errors.arts_elective_one
                                              ? "is-invalid"
                                              : ""
                                              }`}
                                            disabled={isPreviewed || !["REGULAR", "PRIVATE"].includes(formData.category_choice)}
                                            id="arts_elective_one"
                                            name="arts_elective_one"
                                            value={artselective}
                                            onChange={(e) => {
                                              setArtselective(e.target.value);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;
                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  artselective: selectedText,
                                                })
                                              );
                                            }}
                                          >
                                            <option value="">
                                              Choose Subject
                                            </option>
                                            {electivefiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  formData.additionalsubject,
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  optional1,
                                                  optional2,
                                                ];
                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames
                                                  );

                                                // ✅ Vocational restriction
                                                const vocationalSelected =
                                                  (selectedArtsSubjects.arts_optional_one &&
                                                    artsSubjects.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        selectedArtsSubjects.arts_optional_one &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_two &&
                                                    artsSubjects.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        selectedArtsSubjects.arts_optional_two &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_three &&
                                                    artsSubjects.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        selectedArtsSubjects.arts_optional_three &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (formData.additionalsubject &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        formData.additionalsubject &&
                                                        s.vocational === "YES"
                                                    ));

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                  "YES" &&
                                                  subject.subjecT_ID !==
                                                  artselective
                                                ) {
                                                  return false;
                                                }
                                                if (
                                                  formData.coresubject ===
                                                  "HNA" &&
                                                  subject.subjecT_ID === "HIN"
                                                ) {
                                                  return false;
                                                }
                                                if (
                                                  formData.coresubject ===
                                                  "ENA" &&
                                                  (subject.subjecT_ID ===
                                                    "ENG" ||
                                                    subject.subjecT_ID ===
                                                    "FEN")
                                                ) {
                                                  return false;
                                                }
                                                return (
                                                  subject.subjecT_ID ===
                                                  artselective ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>
                                          {errors.arts_elective_one && (
                                            <div className="text-danger mt-1 small">
                                              {errors.arts_elective_one}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="col-md-12 mb-3" id="arts_paper3">
                                    <h4>Optional Subjects</h4>
                                    <hr />

                                    <div class="row">
                                      <div className="col-md-4">
                                        <div className="form-group mb-3">
                                          <label>
                                            Optional 1
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <select
                                            className={`form-select ${errors.arts_optional_one
                                              ? "is-invalid"
                                              : ""
                                              }`}
                                            disabled={isPreviewed || !["REGULAR", "PRIVATE"].includes(formData.category_choice)}
                                            id="arts_optional_one"
                                            name="arts_optional_one"
                                            value={
                                              selectedArtsSubjects.arts_optional_one
                                            }
                                            onChange={(e) => {
                                              handleArtsOptionalChange(e);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;
                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  arts_optional_one:
                                                    selectedText,
                                                })
                                              );
                                            }}
                                          >
                                            <option value="">
                                              Choose Subject
                                            </option>
                                            {optionalfiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  formData.additionalsubject,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  optional1,
                                                  optional2,
                                                  artselective,
                                                ];

                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames
                                                  );

                                                // ✅ Vocational restriction: only one vocational allowed
                                                const vocationalSelected = [
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  artselective,
                                                  formData.additionalsubject,
                                                ].some((id) => {
                                                  if (!id) return false;
                                                  return (
                                                    artsSubjects.find(
                                                      (s) =>
                                                        s.subjecT_ID === id &&
                                                        s.vocational === "YES"
                                                    ) ||
                                                    optionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID === id &&
                                                        s.vocational === "YES"
                                                    ) ||
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID === id &&
                                                        s.vocational === "YES"
                                                    )
                                                  );
                                                });

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                  "YES" &&
                                                  subject.subjecT_ID !==
                                                  selectedArtsSubjects.arts_optional_one
                                                ) {
                                                  return false;
                                                }

                                                // ✅ MAT/STA exclusion for Arts
                                                const artsOptionals = [
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                ];
                                                if (
                                                  artsOptionals.includes(
                                                    "MAT"
                                                  ) &&
                                                  subject.subjecT_ID === "STA"
                                                )
                                                  return false;
                                                if (
                                                  artsOptionals.includes(
                                                    "STA"
                                                  ) &&
                                                  subject.subjecT_ID === "MAT"
                                                )
                                                  return false;

                                                // ✅ Keep current selection OR allow unselected subjects
                                                return (
                                                  subject.subjecT_ID ===
                                                  selectedArtsSubjects.arts_optional_one ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>
                                          {errors.arts_optional_one && (
                                            <div className="text-danger mt-1 small">
                                              {errors.arts_optional_one}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group mb-3">
                                          <label>
                                            Optional 2{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <select
                                            disabled={isPreviewed || !["REGULAR", "PRIVATE"].includes(formData.category_choice)}
                                            className={`form-select ${errors.arts_optional_two
                                              ? "is-invalid"
                                              : ""
                                              }`}
                                            id="arts_optional_two"
                                            name="arts_optional_two"
                                            value={
                                              selectedArtsSubjects.arts_optional_two
                                            }
                                            onChange={(e) => {
                                              handleArtsOptionalChange(e);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;
                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  arts_optional_two:
                                                    selectedText,
                                                })
                                              );
                                            }}
                                          >
                                            <option value="">
                                              Choose Subject
                                            </option>
                                            {optionalfiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  formData.additionalsubject,
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  optional1,
                                                  optional2,
                                                  artselective,
                                                ];
                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames
                                                  );

                                                // ✅ Vocational restriction
                                                const vocationalSelected = [
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  artselective,
                                                  formData.additionalsubject,
                                                ].some(
                                                  (id) =>
                                                    id &&
                                                    (artsSubjects.find(
                                                      (s) =>
                                                        s.subjecT_ID === id &&
                                                        s.vocational === "YES"
                                                    ) ||
                                                      optionalfiltersubj.find(
                                                        (s) =>
                                                          s.subjecT_ID === id &&
                                                          s.vocational === "YES"
                                                      ) ||
                                                      additionalfiltersubj.find(
                                                        (s) =>
                                                          s.subjecT_ID === id &&
                                                          s.vocational === "YES"
                                                      ))
                                                );

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                  "YES" &&
                                                  subject.subjecT_ID !==
                                                  selectedArtsSubjects.arts_optional_two
                                                ) {
                                                  return false;
                                                }

                                                // ✅ MAT/STA exclusion
                                                const artsOptionals = [
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_three,
                                                ].filter(Boolean);

                                                if (
                                                  artsOptionals.includes(
                                                    "MAT"
                                                  ) &&
                                                  subject.subjecT_ID === "STA"
                                                )
                                                  return false;
                                                if (
                                                  artsOptionals.includes(
                                                    "STA"
                                                  ) &&
                                                  subject.subjecT_ID === "MAT"
                                                )
                                                  return false;

                                                return (
                                                  subject.subjecT_ID ===
                                                  selectedArtsSubjects.arts_optional_two ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>

                                          {errors.arts_optional_two && (
                                            <div className="text-danger mt-1 small">
                                              {errors.arts_optional_two}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group mb-3">
                                          <label>
                                            Optional 3{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <select
                                            disabled={isPreviewed || !["REGULAR", "PRIVATE"].includes(formData.category_choice)}
                                            className={`form-select ${errors.arts_optional_three
                                              ? "is-invalid"
                                              : ""
                                              }`}
                                            id="arts_optional_three"
                                            name="arts_optional_three"
                                            value={
                                              selectedArtsSubjects.arts_optional_three
                                            }
                                            onChange={(e) => {
                                              handleArtsOptionalChange(e);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;
                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  arts_optional_three:
                                                    selectedText,
                                                })
                                              );
                                            }}
                                          >
                                            <option value="">
                                              Choose Subject
                                            </option>
                                            {optionalfiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  formData.additionalsubject,
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  optional1,
                                                  optional2,
                                                  artselective,
                                                ];
                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames
                                                  );

                                                // ✅ Vocational restriction
                                                const vocationalSelected = [
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  artselective,
                                                  formData.additionalsubject,
                                                ].some(
                                                  (id) =>
                                                    id &&
                                                    (artsSubjects.find(
                                                      (s) =>
                                                        s.subjecT_ID === id &&
                                                        s.vocational === "YES"
                                                    ) ||
                                                      optionalfiltersubj.find(
                                                        (s) =>
                                                          s.subjecT_ID === id &&
                                                          s.vocational === "YES"
                                                      ) ||
                                                      additionalfiltersubj.find(
                                                        (s) =>
                                                          s.subjecT_ID === id &&
                                                          s.vocational === "YES"
                                                      ))
                                                );

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                  "YES" &&
                                                  subject.subjecT_ID !==
                                                  selectedArtsSubjects.arts_optional_three
                                                ) {
                                                  return false;
                                                }

                                                // ✅ MAT/STA exclusion
                                                const artsOptionals = [
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                ].filter(Boolean);

                                                if (
                                                  artsOptionals.includes(
                                                    "MAT"
                                                  ) &&
                                                  subject.subjecT_ID === "STA"
                                                )
                                                  return false;
                                                if (
                                                  artsOptionals.includes(
                                                    "STA"
                                                  ) &&
                                                  subject.subjecT_ID === "MAT"
                                                )
                                                  return false;

                                                return (
                                                  subject.subjecT_ID ===
                                                  selectedArtsSubjects.arts_optional_three ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>

                                          {errors.arts_optional_three && (
                                            <div className="text-danger mt-1 small">
                                              {errors.arts_optional_three}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="col-md-12" id="arts_additional">
                                    <h4>Additional Subject </h4>
                                    <hr />
                                    <div class="row">
                                      <div className="col-md-4 mb-2">
                                        <div className="form-group mb-3">
                                          <select
                                            disabled={isPreviewed || !["REGULAR", "PRIVATE"].includes(formData.category_choice)}
                                            className="form-select"
                                            id="additionalsubject"
                                            name="additionalsubject"
                                            value={
                                              formData.additionalsubject || ""
                                            }
                                            onChange={(e) => {
                                              handleChange(e);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;

                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  additionalsubject:
                                                    selectedText,
                                                })
                                              );
                                            }}
                                          >
                                            <option value="">
                                              Choose Subject
                                            </option>
                                            {additionalfiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  optional1,
                                                  optional2,
                                                  artselective,
                                                ];

                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames
                                                  );

                                                const vocationalSelected =
                                                  (optional1 &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        optional1 &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (optional2 &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        optional2 &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_one &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        selectedArtsSubjects.arts_optional_one &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_two &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        selectedArtsSubjects.arts_optional_two &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_three &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        selectedArtsSubjects.arts_optional_three &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (artselective &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        artselective &&
                                                        s.vocational === "YES"
                                                    ));

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                  "YES" &&
                                                  subject.subjecT_ID !==
                                                  formData.additionalsubject
                                                ) {
                                                  return false; // hide all vocational except the one already chosen
                                                }
                                                // ✅ Language-based restrictions
                                                if (
                                                  formData.coresubject ===
                                                  "HNA" &&
                                                  subject.subjecT_ID === "HIN"
                                                ) {
                                                  return false;
                                                }
                                                if (
                                                  formData.coresubject ===
                                                  "ENA" &&
                                                  (subject.subjecT_ID ===
                                                    "ENG" ||
                                                    subject.subjecT_ID ===
                                                    "FEN")
                                                ) {
                                                  return false;
                                                }

                                                // ✅ Science stream restrictions
                                                if (
                                                  formData.stream === "SCIENCE"
                                                ) {
                                                  if (
                                                    (optional1 === "MAT" ||
                                                      optional2 === "MAT") &&
                                                    subject.subjecT_ID === "STA"
                                                  ) {
                                                    return false;
                                                  }
                                                  if (
                                                    (optional1 === "STA" ||
                                                      optional2 === "STA") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Commerce stream restrictions
                                                if (
                                                  formData.stream === "COMMERCE"
                                                ) {
                                                  if (
                                                    (optional1 === "MAT" ||
                                                      optional2 === "MAT") &&
                                                    subject.subjecT_ID === "CAE"
                                                  ) {
                                                    return false;
                                                  }
                                                  if (
                                                    (optional1 === "CAE" ||
                                                      optional2 === "CAE") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Arts stream MAT/STA restrictions
                                                if (
                                                  formData.stream === "ARTS"
                                                ) {
                                                  const {
                                                    arts_optional_one,
                                                    arts_optional_two,
                                                    arts_optional_three,
                                                  } = selectedArtsSubjects;

                                                  // If MAT selected anywhere, remove both MAT & STA
                                                  if (
                                                    arts_optional_one ===
                                                    "MAT" ||
                                                    arts_optional_two ===
                                                    "MAT" ||
                                                    arts_optional_three ===
                                                    "MAT"
                                                  ) {
                                                    if (
                                                      subject.subjecT_ID ===
                                                      "MAT" ||
                                                      subject.subjecT_ID ===
                                                      "STA"
                                                    ) {
                                                      return false;
                                                    }
                                                  }

                                                  // If STA selected anywhere, remove both STA & MAT
                                                  if (
                                                    arts_optional_one ===
                                                    "STA" ||
                                                    arts_optional_two ===
                                                    "STA" ||
                                                    arts_optional_three ===
                                                    "STA"
                                                  ) {
                                                    if (
                                                      subject.subjecT_ID ===
                                                      "STA" ||
                                                      subject.subjecT_ID ===
                                                      "MAT"
                                                    ) {
                                                      return false;
                                                    }
                                                  }
                                                }

                                                // ✅ Keep current selection OR allow unselected subjects
                                                return (
                                                  subject.subjecT_ID ===
                                                  formData.additionalsubject ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {formData.category_choice !== "EX-REGULAR" && (
                  <div class="col-lg-3 col-m-12 mb-4 stretch-card">
                    <div class="card">
                      <div class="card-header card-green">
                        <h4 class="mb-0 p-2">Other Details</h4>
                      </div>
                      <div class="card-body">
                        <div class="form-group mb-3">
                          <label>
                            Permanent Education Number (PEN){" "}
                            <span class="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            id="pen_no"
                            name="pen_no"
                            className={`form-control form-control-sm ${errors.pen_no ? "is-invalid" : ""
                              }`}
                            placeholder="Enter PEN NO"
                            value={formData.pen_no}
                            maxlength="14"
                            onBlur={handlePenBlur}
                            onChange={(e) => {
                              const onlyNums2 = e.target.value.replace(
                                /\D/g,
                                ""
                              );
                              handleChange({
                                target: { name: "pen_no", value: onlyNums2 },
                              });
                            }}
                            disabled={isPreviewed}
                          />
                          {errors.pen_no && (
                            <div className="text-danger mt-1 small">
                              {errors.pen_no}
                            </div>
                          )}
                        </div>
                        <div class="form-group mb-3">
                          <label>APAAR ID</label>
                          <input
                            maxlength="12"
                            type="text"
                            id="apaar_id"
                            name="apaar_id"
                            className={`form-control form-control-sm ${errors.apaar_id ? "is-invalid" : ""
                              }`}
                            placeholder="Enter APAAR ID"
                            value={formData.apaar_id}
                            onChange={(e) => {
                              const onlyNums = e.target.value.replace(/\D/g, "");
                              handleChange({
                                target: { name: "apaar_id", value: onlyNums },
                              });
                            }}
                            // onBlur={handleApaarBlur}
                            disabled={isPreviewed}
                          />
                          {errors.apaar_id && (
                            <div className="text-danger mt-1 small">
                              {errors.apaar_id}
                            </div>
                          )}
                        </div>

                      </div>
                    </div>
                  </div>
                )}
                <div class="col-lg-12 mb-4 stretch-card">
                  <div class="card">
                    <div class="card-header card-green">
                      <h4 class="mb-0 p-2">Uploaded Documents</h4>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div className="col-md-3">
                          <div>
                            <h4 style={{ textAlign: "center" }}>Photograph</h4>
                          </div>
                          <div
                            style={{
                              width: "98%",
                              padding: "10px",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                            className="file-upload"
                            data-toggle="tooltip"
                            data-placement="top"
                            data-bs-original-title="Document Format : JPG<br>Min Size : 10 KB<br>Max Size : 40KB"
                          >
                            <div className="file-select2">
                              <div className="imagePreview2" id="photograph">
                                {(photoBase64 || photourl) && (
                                  <img
                                    src={photoBase64 || photourl}
                                    alt="Preview"
                                    style={{
                                      width: "180px",
                                      height: "180px",
                                      objectFit: "contain",
                                      borderRadius: "6px",
                                    }}
                                  />
                                )}
                              </div>
                              {!isPreviewed && (
                                <button className="btn btn-secondary btn-sm file_btn">
                                  Choose File
                                </button>
                              )}
                              <div
                                className="file-select-name2"
                                id="photograph_name"
                              >
                                {photoName
                                  ? photoName.length > 60
                                    ? `${photoName.slice(0, 60)}...`
                                    : photoName
                                  : "No File Chosen"}
                              </div>
                              {!isPreviewed && (
                                <input
                                  type="file"
                                  ref={photographRef}
                                  className="profileimg form-control"
                                  id="upload_photograph"
                                  accept=".JPG,.JPEG"
                                  onChange={(e) => handlePhotoChange(e)}
                                  style={{
                                    position: "absolute",
                                    opacity: 0,
                                    left: 0,
                                    bottom: 0,
                                    top: 0,
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div>
                            <h4 style={{ textAlign: "center" }}>Signature</h4>
                          </div>
                          <div
                            style={{
                              width: "98%",
                              padding: "10px",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                            className="file-upload"
                            data-toggle="tooltip"
                            data-placement="top"
                            data-bs-original-title="Document Format : JPG<br>Min Size : 10 KB<br>Max Size : 40KB"
                          >
                            <div className="file-select2">
                              <div className="imagePreview2" id="signature">
                                {(signBase64 || signurl) && (
                                  <img
                                    src={signBase64 || signurl}
                                    alt="Preview"
                                    style={{
                                      width: "180px",
                                      height: "180px",
                                      objectFit: "contain",
                                      borderRadius: "6px",
                                    }}
                                  />
                                )}
                              </div>
                              {!isPreviewed && (
                                <button className="btn btn-secondary btn-sm file_btn">
                                  Choose File
                                </button>
                              )}
                              <div
                                className="file-select-name2"
                                id="signature_name"
                              >
                                {signName
                                  ? signName.length > 60
                                    ? `${signName.slice(0, 60)}...`
                                    : signName
                                  : "No File Chosen"}
                              </div>
                              {!isPreviewed && (
                                <input
                                  type="file"
                                  ref={signatureRef}
                                  className="profileimg form-control"
                                  id="upload_signature"
                                  accept=".JPG,.JPEG"
                                  onChange={(e) =>
                                    handleChange2(e, "signature")
                                  }
                                  style={{
                                    position: "absolute",
                                    opacity: 0,
                                    left: 0,
                                    bottom: 0,
                                    top: 0,
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                        {/* {formData.caste_val !== "CS_001" && (
                          <div className="col-md-3">
                            <div>
                              <h4 style={{ textAlign: "center" }}>
                                Caste Certificate
                              </h4>
                            </div>
                            <div
                              style={{
                                width: "98%",
                                padding: "10px",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                              className="file-upload"
                              data-toggle="tooltip"
                              data-placement="top"
                              data-bs-original-title="Document Format : JPG<br>Min Size : 10 KB<br>Max Size : 40KB"
                            >
                              <div className="file-select2">
                                <div className="imagePreview2" id="caste">
                                  {casteName && (
                                    <a
                                      href={
                                        isPreviewed
                                          ? undefined
                                          : casteurl || casteBase64
                                      }
                                    >
                                      <FaRegFilePdf
                                        style={{
                                          fontSize: "70px",
                                          marginTop: "50px",
                                        }}
                                        className="text-danger"
                                      />
                                    </a>
                                  )}
                                </div>
                                {!isPreviewed && (
                                  <button className="btn btn-secondary btn-sm file_btn">
                                    Choose File
                                  </button>
                                )}
                                <div
                                  className="file-select-name2"
                                  id="caste_name"
                                >
                                  {casteName
                                    ? casteName.length > 60
                                      ? `${casteName.slice(0, 60)}...`
                                      : casteName
                                    : "No File Chosen"}
                                </div>
                                {!isPreviewed && (
                                  <input
                                    type="file"
                                    ref={casteRef}
                                    className="profileimg form-control"
                                    id="upload_caste"
                                    accept=".PDF"
                                    onChange={(e) => handleChange2(e, "caste")}
                                    style={{
                                      position: "absolute",
                                      opacity: 0,
                                      left: 0,
                                      bottom: "40px",
                                      top: 0,
                                    }}
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        )} */}

                        {formData.divyang_val !== "DIV_001" && (
                          <div className="col-md-3">
                            <div>
                              <h4 style={{ textAlign: "center" }}>
                                Divyang Certificate
                              </h4>
                            </div>
                            <div
                              style={{
                                width: "98%",
                                padding: "10px",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                              className="file-upload"
                              data-toggle="tooltip"
                              data-placement="top"
                              data-bs-original-title="Document Format : JPG<br>Min Size : 10 KB<br>Max Size : 40KB"
                            >
                              <div className="file-select2">
                                <div className="imagePreview2" id="divyang">
                                  {divyangName && (
                                    <a
                                      href={
                                        isPreviewed
                                          ? undefined
                                          : divyangurl || divyangBase64
                                      }
                                    >
                                      <FaRegFilePdf
                                        style={{
                                          fontSize: "70px",
                                          marginTop: "50px",
                                        }}
                                        className="text-danger"
                                      />
                                    </a>
                                  )}
                                </div>
                                {!isPreviewed && (
                                  <button className="btn btn-secondary btn-sm file_btn">
                                    Choose File
                                  </button>
                                )}
                                <div
                                  className="file-select-name2"
                                  id="divyang_name"
                                >
                                  {divyangName
                                    ? divyangName.length > 60
                                      ? `${divyangName.slice(0, 60)}...`
                                      : divyangName
                                    : "No File Chosen"}
                                </div>
                                {!isPreviewed && (
                                  <input
                                    type="file"
                                    ref={divyangRef}
                                    className="profileimg form-control"
                                    id="upload_divyang"
                                    accept=".PDF"
                                    onChange={(e) =>
                                      handleChange2(e, "divyang")
                                    }
                                    style={{
                                      position: "absolute",
                                      opacity: 0,
                                      left: 0,
                                      bottom: "40px",
                                      top: 0,
                                    }}
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="card">
                    <div class="card-body">
                      <div className="row">
                        <div className="col-md-8">
                          {isPreviewed && (
                            <h5 style={{ color: "red" }}>
                              <input
                                type="checkbox"
                                checked={isAgreed}
                                onChange={(e) => setIsAgreed(e.target.checked)}
                              />{" "}
                              I AGREE THAT ALL THE INFORMATION GIVEN ABOVE IS
                              CORRECT AS PER MY BEST KNOWLEDGE.
                            </h5>
                          )}
                        </div>
                        <div
                          style={{ textAlign: "right" }}
                          className="col-md-4"
                        >
                          {isEditMode ? (
                            <>
                              <button
                                onClick={handleEditClick}
                                type="button"
                                className="btn btn-primary"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </button>
                              &nbsp;&nbsp;
                              <button
                                type="button"
                                onClick={handleContinueClick}
                                className="btn btn-success me-2"
                              >
                                Next <i className="fa fa-arrow-right me-1"></i>
                              </button>
                            </>
                          ) : isPreviewed ? (
                            <>
                              <button
                                onClick={handleButtonClick}
                                type="button"
                                className="btn btn-primary pull-right"
                              >
                                <i className="fa fa-save me-1"></i>
                                Submit
                              </button>
                              <button
                                type="button"
                                onClick={() => setIsPreviewed(false)}
                                className="btn btn-secondary me-2"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </button>
                            </>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary me-2"
                              onClick={handlePreview}
                            >
                              <i className="fa fa-eye me-1"></i> Preview
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
      {showCropper && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.6)",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              background: "#fff",
              width: "600px",
              margin: "100px auto",
              padding: "20px",
              borderRadius: "8px",
            }}
          >
            <Cropper
              src={cropperImage}
              style={{ height: 400, width: "100%" }}
              aspectRatio={3 / 4}
              guides={true}
              ref={cropperRef}
            />
            <div style={{ marginTop: "10px", textAlign: "right" }}>
              <button className="btn btn-primary" onClick={handleCropConfirm}>
                Crop & Validate
              </button>
              <button
                className="btn btn-secondary"
                style={{ marginLeft: "10px" }}
                onClick={handleCropCancel}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default StudentCorrectionPage11;
